//https://cdn.haworth.com/haworth-configurator/0.0.33/assets/w-cf/scripts/bsk.min.js
'use strict';
var egr,
  __awaiter =
    (this && this.__awaiter) ||
    function (e, s, o, l) {
      return new (o = o || Promise)(function (r, t) {
        function n(e) {
          try {
            a(l.next(e));
          } catch (e) {
            t(e);
          }
        }
        function i(e) {
          try {
            a(l.throw(e));
          } catch (e) {
            t(e);
          }
        }
        function a(e) {
          var t;
          e.done
            ? r(e.value)
            : ((t = e.value) instanceof o
                ? t
                : new o(function (e) {
                    e(t);
                  })
              ).then(n, i);
        }
        a((l = l.apply(e, s || [])).next());
      });
    },
  __generator =
    (this && this.__generator) ||
    function (r, n) {
      var i,
        a,
        s,
        o = {
          label: 0,
          sent: function () {
            if (1 & s[0]) throw s[1];
            return s[1];
          },
          trys: [],
          ops: [],
        },
        e = { next: t(0), throw: t(1), return: t(2) };
      return (
        'function' == typeof Symbol &&
          (e[Symbol.iterator] = function () {
            return this;
          }),
        e
      );
      function t(t) {
        return function (e) {
          return (function (t) {
            if (i) throw new TypeError('Generator is already executing.');
            for (; o; )
              try {
                if (
                  ((i = 1),
                  a &&
                    (s =
                      2 & t[0]
                        ? a.return
                        : t[0]
                        ? a.throw || ((s = a.return) && s.call(a), 0)
                        : a.next) &&
                    !(s = s.call(a, t[1])).done)
                )
                  return s;
                switch (((a = 0), s && (t = [2 & t[0], s.value]), t[0])) {
                  case 0:
                  case 1:
                    s = t;
                    break;
                  case 4:
                    return o.label++, { value: t[1], done: !1 };
                  case 5:
                    o.label++, (a = t[1]), (t = [0]);
                    continue;
                  case 7:
                    (t = o.ops.pop()), o.trys.pop();
                    continue;
                  default:
                    if (
                      !(s = 0 < (s = o.trys).length && s[s.length - 1]) &&
                      (6 === t[0] || 2 === t[0])
                    ) {
                      o = 0;
                      continue;
                    }
                    if (3 === t[0] && (!s || (t[1] > s[0] && t[1] < s[3]))) {
                      o.label = t[1];
                      break;
                    }
                    if (6 === t[0] && o.label < s[1]) {
                      (o.label = s[1]), (s = t);
                      break;
                    }
                    if (s && o.label < s[2]) {
                      (o.label = s[2]), o.ops.push(t);
                      break;
                    }
                    s[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }
                t = n.call(r, o);
              } catch (e) {
                (t = [6, e]), (a = 0);
              } finally {
                i = s = 0;
              }
            if (5 & t[0]) throw t[1];
            return { value: t[0] ? t[1] : void 0, done: !0 };
          })([t, e]);
        };
      }
    },
  __extends =
    (this && this.__extends) ||
    (function () {
      var n = function (e, t) {
        return (n =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function (e, t) {
              e.__proto__ = t;
            }) ||
          function (e, t) {
            for (var r in t) t.hasOwnProperty(r) && (e[r] = t[r]);
          })(e, t);
      };
      return function (e, t) {
        function r() {
          this.constructor = e;
        }
        n(e, t),
          (e.prototype =
            null === t
              ? Object.create(t)
              : ((r.prototype = t.prototype), new r()));
      };
    })();
!(function (e) {
  var s;
  (function (n) {
    var e;
    ((e = n.ItemUpdateFlags || (n.ItemUpdateFlags = {}))[(e.None = 0)] =
      'None'),
      (e[(e.Item = 1)] = 'Item'),
      (e[(e.ItemProps = 2)] = 'ItemProps'),
      (e[(e.Image = 4)] = 'Image'),
      (e[(e.Calculation = 8)] = 'Calculation'),
      (e[(e.Tax = 16)] = 'Tax'),
      (e[(e.ConfigData = 32)] = 'ConfigData'),
      (e[(e.UserImage = 64)] = 'UserImage'),
      (e[(e.ExtItemNumber = 128)] = 'ExtItemNumber'),
      (e[(e.IncludeChildren = 2147483648)] = 'IncludeChildren'),
      (e[(e.All = 4294967295)] = 'All');
    var t =
      (Object.defineProperty(r.prototype, 'id', {
        get: function () {
          return this.mItem.itemId;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'label', {
        get: function () {
          return this.mItem.label;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'type', {
        get: function () {
          return this.mItem.itemType;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'item', {
        get: function () {
          return this.mItem;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'parent', {
        get: function () {
          return this.mParent;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'children', {
        get: function () {
          return this.mChildren;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'childIndex', {
        get: function () {
          return this.mChildIndex;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'isSelected', {
        get: function () {
          return this.mIsSelected;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'isDisposed', {
        get: function () {
          return void 0 === this.mChildren;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'userData', {
        get: function () {
          return this.mUserData;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'isGroup', {
        get: function () {
          return !1;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'isOfmlArticle', {
        get: function () {
          return !1;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (r.prototype.canEditLabel = function () {
        return 'setLabel' in this;
      }),
      (r.prototype.isExcludedFromCalculations = function () {
        var e = this.getCachedItemProperties();
        if (
          null != e &&
          null != e.article &&
          null != e.article.excludedCalculations
        ) {
          var t = e.article.excludedCalculations;
          if (1 === t.length && '' === t[0]) return !0;
          var r = this.mManager._getPricingProcedure();
          if (null != r) return s.utils.array.contains(t, r.name);
        }
      }),
      (r.prototype.getItemProperties = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [
                  4,
                  this.mManager._fetchItemPropertiesLock.acquireLock(),
                ];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 6, 7]),
                  void 0 === this.mItemProps ? [3, 3] : [2, this.mItemProps]
                );
              case 3:
                return [4, (r = this).mManager._getItemProps(this.id)];
              case 4:
                return (
                  (r.mItemProps = e.sent()),
                  this.handleChangedItemProps(),
                  [2, this.mItemProps]
                );
              case 5:
                return [3, 7];
              case 6:
                return t.unlock(), [7];
              case 7:
                return [2];
            }
          });
        });
      }),
      (r.prototype.getCachedItemProperties = function () {
        return this.mItemProps;
      }),
      (r.prototype.fetchItemProperties = function (a, s) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return a
                  ? [4, this.mManager._fetchItemPropertiesLock.acquireLock()]
                  : [3, 9];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                if (
                  (e.trys.push([2, , 7, 8]),
                  !(
                    0 <
                    (r = this.collectItemsToFetch(function (e) {
                      return null == e.mItemProps;
                    }, s)).items.length
                  ))
                )
                  return [3, 6];
                e.label = 3;
              case 3:
                return (
                  e.trys.push([3, , 5, 6]),
                  this.mManager._beginCaching(),
                  [4, this.mManager._fetchItemProps(r.itemIds, !1, !1)]
                );
              case 4:
                for (e.sent(), n = 0, i = r.items; n < i.length; n++)
                  i[n].useItemPropsFromCache();
                return [3, 6];
              case 5:
                return this.mManager._endCaching(), [7];
              case 6:
                return [3, 8];
              case 7:
                return t.unlock(), [7];
              case 8:
                return [3, 11];
              case 9:
                return null == s || s(this.asT)
                  ? [4, this.getItemProperties()]
                  : [3, 11];
              case 10:
                e.sent(), (e.label = 11);
              case 11:
                return [2];
            }
          });
        });
      }),
      (r.prototype.getImageUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return null != this.mImageUrl
                  ? [3, 2]
                  : [4, this.generateImageUrl()];
              case 1:
                e.sent(), (e.label = 2);
              case 2:
                return null != this.mImageUrl ? [2, this.mImageUrl] : [2, null];
            }
          });
        });
      }),
      (r.prototype.getCachedImageUrl = function () {
        return this.mImageUrl;
      }),
      (r.prototype.getUserImageUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mManager._fetchUserImagesLock.acquireLock()];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 6, 7]),
                  void 0 === this.mUserImageUrl
                    ? [3, 3]
                    : [2, this.mUserImageUrl]
                );
              case 3:
                return [4, (r = this).mManager._getItemUserImage(this.id)];
              case 4:
                return (r.mUserImageUrl = e.sent()), [2, this.mUserImageUrl];
              case 5:
                return [3, 7];
              case 6:
                return t.unlock(), [7];
              case 7:
                return [2];
            }
          });
        });
      }),
      (r.prototype.getCachedUserImageUrl = function () {
        return this.mUserImageUrl;
      }),
      (r.prototype.fetchUserImageUrls = function (a, s) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return a
                  ? [4, this.mManager._fetchUserImagesLock.acquireLock()]
                  : [3, 9];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                if (
                  (e.trys.push([2, , 7, 8]),
                  !(
                    0 <
                    (r = this.collectItemsToFetch(function (e) {
                      return void 0 === e.mUserImageUrl;
                    }, s)).items.length
                  ))
                )
                  return [3, 6];
                e.label = 3;
              case 3:
                return (
                  e.trys.push([3, , 5, 6]),
                  this.mManager._beginCaching(),
                  [4, this.mManager._fetchItemUserImages(r.itemIds, !1, !1)]
                );
              case 4:
                for (e.sent(), n = 0, i = r.items; n < i.length; n++)
                  i[n].useUserImageFromCache();
                return [3, 6];
              case 5:
                return this.mManager._endCaching(), [7];
              case 6:
                return [3, 8];
              case 7:
                return t.unlock(), [7];
              case 8:
                return [3, 11];
              case 9:
                return null == s || s(this.asT)
                  ? [4, this.getUserImageUrl()]
                  : [3, 11];
              case 10:
                e.sent(), (e.label = 11);
              case 11:
                return [2];
            }
          });
        });
      }),
      (r.prototype.getCalculation = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mManager._fetchCalculationsLock.acquireLock()];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 6, 7]),
                  void 0 === this.mCalculation ? [3, 3] : [2, this.mCalculation]
                );
              case 3:
                return [4, (r = this).mManager._getItemCalculation(this.id)];
              case 4:
                return (r.mCalculation = e.sent()), [2, this.mCalculation];
              case 5:
                return [3, 7];
              case 6:
                return t.unlock(), [7];
              case 7:
                return [2];
            }
          });
        });
      }),
      (r.prototype.getCachedCalculation = function () {
        return this.mCalculation;
      }),
      (r.prototype.fetchCalculations = function (a, s) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return a
                  ? [4, this.mManager._fetchCalculationsLock.acquireLock()]
                  : [3, 9];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                if (
                  (e.trys.push([2, , 7, 8]),
                  !(
                    0 <
                    (r = this.collectItemsToFetch(function (e) {
                      return null == e.mCalculation;
                    }, s)).items.length
                  ))
                )
                  return [3, 6];
                e.label = 3;
              case 3:
                return (
                  e.trys.push([3, , 5, 6]),
                  this.mManager._beginCaching(),
                  [4, this.mManager._fetchItemCalculations(r.itemIds, !1, !1)]
                );
              case 4:
                for (e.sent(), n = 0, i = r.items; n < i.length; n++)
                  i[n].useCalculationFromCache();
                return [3, 6];
              case 5:
                return this.mManager._endCaching(), [7];
              case 6:
                return [3, 8];
              case 7:
                return t.unlock(), [7];
              case 8:
                return [3, 11];
              case 9:
                return null == s || s(this.asT)
                  ? [4, this.getCalculation()]
                  : [3, 11];
              case 10:
                e.sent(), (e.label = 11);
              case 11:
                return [2];
            }
          });
        });
      }),
      (r.prototype.getExtItemNumber = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [
                  4,
                  this.mManager._fetchExtItemNumbersLock.acquireLock(),
                ];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 6, 7]),
                  void 0 === this.mExtItemNumber
                    ? [3, 3]
                    : [2, this.mExtItemNumber]
                );
              case 3:
                return [4, (r = this).mManager._getExtItemNumber(this.id)];
              case 4:
                return (r.mExtItemNumber = e.sent()), [2, this.mExtItemNumber];
              case 5:
                return [3, 7];
              case 6:
                return t.unlock(), [7];
              case 7:
                return [2];
            }
          });
        });
      }),
      (r.prototype.getCachedExtItemNumber = function () {
        return this.mExtItemNumber;
      }),
      (r.prototype.fetchExtItemNumbers = function (a, s) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return a
                  ? [4, this.mManager._fetchExtItemNumbersLock.acquireLock()]
                  : [3, 9];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                if (
                  (e.trys.push([2, , 7, 8]),
                  !(
                    0 <
                    (r = this.collectItemsToFetch(function (e) {
                      return void 0 === e.mExtItemNumber;
                    }, s)).items.length
                  ))
                )
                  return [3, 6];
                e.label = 3;
              case 3:
                return (
                  e.trys.push([3, , 5, 6]),
                  this.mManager._beginCaching(),
                  [4, this.mManager._fetchExtItemNumbers(r.itemIds, !1, !1)]
                );
              case 4:
                for (e.sent(), n = 0, i = r.items; n < i.length; n++)
                  i[n].useExtItemNumberFromCache();
                return [3, 6];
              case 5:
                return this.mManager._endCaching(), [7];
              case 6:
                return [3, 8];
              case 7:
                return t.unlock(), [7];
              case 8:
                return [3, 11];
              case 9:
                return null == s || s(this.asT)
                  ? [4, this.getExtItemNumber()]
                  : [3, 11];
              case 10:
                e.sent(), (e.label = 11);
              case 11:
                return [2];
            }
          });
        });
      }),
      (r.prototype.invalidateCalculation = function (e, t) {
        if (
          (this.useCalculationFromCache(),
          t &&
            this.mManager.eventItemUpdated.trigger({
              item: this.asT,
              flags: 8,
            }),
          e)
        )
          for (var r = 0, n = this.mChildren; r < n.length; r++)
            n[r].invalidateCalculation(e, t);
      }),
      (r.prototype.invalidateGroupCalculations = function () {
        this.isGroup && this.invalidateCalculation(!1, !0);
        var e = this.internalGetSetArticle(),
          t = this.getParentGroup();
        null != e && e != t && e.invalidateGroupCalculations(),
          null != t
            ? t.invalidateGroupCalculations()
            : this.mManager.invalidateHeaderCalculation();
      }),
      (r.prototype.getParentGroup = function () {
        return null == this.mParent
          ? null
          : this.mParent.isGroup
          ? this.mParent
          : this.mParent.getParentGroup();
      }),
      (r.prototype.updateItem = function (t) {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  e.trys.push([0, , 4, 5]),
                  this.mManager._beginItemUpdate(),
                  this.mManager._beginCaching(),
                  0 == (1 & t) || 0 == (2147483648 & t)
                    ? [3, 2]
                    : [4, this.mManager._fetchEaiwsItems([this.id], !0, !1)]
                );
              case 1:
                e.sent(), (e.label = 2);
              case 2:
                return [4, this.performUpdates(t)];
              case 3:
                return (
                  e.sent(),
                  0 != (8 & t) && this.invalidateGroupCalculations(),
                  [3, 5]
                );
              case 4:
                return (
                  this.mManager._endCaching(),
                  this.mManager._endItemUpdate(),
                  [7]
                );
              case 5:
                return [2];
            }
          });
        });
      }),
      (r.prototype.isChildOf = function (e, t) {
        if (null == e || e === this.asT) return !1;
        if (t) return this.mParent === e;
        for (var r = this.mParent; null != r; ) {
          if (r === e) return !0;
          r = r.parent;
        }
        return !1;
      }),
      (r.prototype.getPrevChild = function (e) {
        for (var t = e; null != t && t.parent !== this.asT; ) t = t.parent;
        if (null == t) return null;
        var r = t.mChildIndex;
        return 0 < r ? this.mChildren[r - 1] : null;
      }),
      (r.prototype.getNextChild = function (e) {
        for (var t = e; null != t && t.parent !== this.asT; ) t = t.parent;
        if (null == t) return null;
        var r = t.mChildIndex;
        return 0 <= r && r + 1 < this.mChildren.length
          ? this.mChildren[r + 1]
          : null;
      }),
      (r.prototype.getItemNumber = function () {
        return (
          null != this.mItemNumber ||
            (this.mItemNumber = this._getItemNumberAsArray().join('.')),
          this.mItemNumber
        );
      }),
      (r.prototype._rebuildChildList = function (d) {
        return __awaiter(this, void 0, void 0, function () {
          var t,
            r,
            n,
            i,
            a,
            s,
            o,
            l,
            c,
            u,
            h,
            m = this;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                for (
                  t = this.mManager._isCaching(),
                    r = new Map(),
                    n = 0,
                    i = this.mChildren;
                  n < i.length;
                  n++
                )
                  (a = i[n]), r.set(a.id, a);
                if (
                  ((this.mChildren = new Array()),
                  null == this.mItem.subItemIds)
                )
                  return [3, 8];
                (s = 0 != (2147483648 & d)),
                  (o = 0),
                  (l = this.mItem.subItemIds),
                  (e.label = 1);
              case 1:
                return o < l.length
                  ? ((c = l[o]),
                    (u = this.mChildren.length),
                    null == (h = this.mManager.getItemById(c))
                      ? [3, 4]
                      : (h.setParent(this.asT, u),
                        s ? [4, h.performUpdates(d)] : [3, 3]))
                  : [3, 8];
              case 2:
                e.sent(), (e.label = 3);
              case 3:
                return [3, 6];
              case 4:
                return [4, this.mManager._createItem(c, this.asT, u, !0)];
              case 5:
                (h = e.sent()), (e.label = 6);
              case 6:
                null != h &&
                  (this.mChildren.push(h),
                  r.delete(h.id),
                  t && this.mManager._deletedItemsCache.delete(h.id)),
                  (e.label = 7);
              case 7:
                return o++, [3, 1];
              case 8:
                return (
                  t
                    ? r.forEach(function (e) {
                        return m.mManager._deletedItemsCache.set(e.id, e);
                      })
                    : r.forEach(function (e) {
                        return e._dispose();
                      }),
                  [2]
                );
            }
          });
        });
      }),
      (r.prototype._dispose = function () {
        if (!this.isDisposed) {
          this.mManager.eventItemDisposed.trigger(this.asT),
            this.mManager._deregisterItem(this.asT);
          for (var e = 0, t = this.mChildren; e < t.length; e++)
            t[e]._dispose();
          this.mChildren = void 0;
        }
      }),
      (r.prototype._setIsSelected = function (e) {
        this.mIsSelected = e;
      }),
      (r.prototype._getArticleData = function (e) {
        return this.mManager.session.basket.getArticleData(this.id, e);
      }),
      (r.prototype._getItemNumberAsArray = function () {
        return (
          null != this.mItemNumberArray ||
            (null == this.mParent
              ? (this.mItemNumberArray = [])
              : ((this.mItemNumberArray = s.utils.array.clone(
                  this.mParent._getItemNumberAsArray()
                )),
                this.mItemNumberArray.push(this.mChildIndex + 1))),
          this.mItemNumberArray
        );
      }),
      (r.prototype.getGeneratedImage = function (e) {
        var t = this.mManager._getGeneratedImageOptions(),
          r = this.mManager._getViewId();
        return (
          (null == r && null == e) ||
            ((t = s.utils.array.clone(t)),
            null != e &&
              t.push(
                'alpha=' + e.alpha.toString(),
                'beta=' + e.beta.toString(),
                'zoom=' + e.fov.toString(),
                'projectionMode=' + e.mode
              ),
            null != r && t.push('viewId=' + r)),
          this.mManager.session.basket
            .getGeneratedImage(this.id, t)
            .then(function (e) {
              return s.utils.string.isNullOrEmpty(e) ? null : e;
            })
        );
      }),
      (r.prototype.getCatalogImage = function () {
        var e = new s.eaiws.basket.GetArticleDataOptions();
        return (
          (e.noProperties = !0),
          (e.fetchCatalogIcon = !0),
          (e.fetchCatalogImage = !0),
          (e.viewId = this.mManager._getViewId()),
          this._getArticleData(e).then(function (e) {
            var t = void 0,
              t = e.catalogImage;
            return (
              s.utils.string.isNullOrEmpty(t) && (t = e.catalogIcon),
              s.utils.string.isNullOrEmpty(t) ? null : t
            );
          })
        );
      }),
      (r.prototype.getStoredImage = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  ((t = new s.eaiws.basket.GetImagesOptions()).useCache = !0),
                  (t.attributes = !0),
                  (t.viewId = this.mManager._getViewId()),
                  [4, this.mManager.session.basket.getImages(this.id, t)]
                );
              case 1:
                if (null != (r = e.sent()))
                  for (n = 0, i = r; n < i.length; n++)
                    if (
                      ((a = i[n]),
                      s.utils.string.isNullOrEmpty(a.tag) &&
                        s.utils.string.isNotNullOrEmpty(a.url))
                    )
                      return [2, a];
                return [2, null];
            }
          });
        });
      }),
      (r.prototype.getCameraSetupFromImage = function (e) {
        if (null == e.attributes || 0 === e.attributes.length) return null;
        for (var t, r, n, i, a = 0, s = e.attributes; a < s.length; a++) {
          var o = s[a];
          o.startsWith('alpha')
            ? (t = this.getImageAttributeValue(o))
            : o.startsWith('beta')
            ? (r = this.getImageAttributeValue(o))
            : o.startsWith('zoom')
            ? (n = this.getImageAttributeValue(o))
            : o.startsWith('projMode') && (i = this.getImageAttributeValue(o));
        }
        if (null == t || null == r) return null;
        var l = {
          alpha: t,
          beta: r,
          mode: 1 === i ? 'Orthographic' : 'Perspective',
          fov: 30,
        };
        return null != n && 'Perspective' === l.mode && (l.fov = n), l;
      }),
      (r.prototype.generateImageUrl = function () {
        return (this.mImageUrl = null), Promise.resolve();
      }),
      (r.prototype.setItemProperties = function (r, n, i) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [
                  4,
                  this.mManager.session.basket.setItemProperties(this.id, r),
                ];
              case 1:
                return (
                  e.sent(),
                  (t = 2),
                  n && (t |= 1),
                  i && ((t |= 8), this.invalidateGroupCalculations()),
                  [2, this.updateItem(t)]
                );
            }
          });
        });
      }),
      (r.prototype.internalGetSetArticle = function () {
        return s.utils.string.isNullOrEmpty(this.mItem.setArticleId)
          ? null
          : this.mManager.getItemById(this.mItem.setArticleId);
      }),
      (r.prototype.performUpdates = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return 0 == (1 & r)
                  ? [3, 2]
                  : [4, (t = this).mManager._getEaiwsItem(this.id)];
              case 1:
                (t.mItem = e.sent()), (e.label = 2);
              case 2:
                return (
                  0 != (2 & r) && this.useItemPropsFromCache(),
                  0 != (8 & r) && this.invalidateCalculation(!1, !1),
                  0 != (4 & r) && (this.mImageUrl = void 0),
                  0 != (64 & r) && this.useUserImageFromCache(),
                  0 != (128 & r) && this.useExtItemNumberFromCache(),
                  0 == (1 & r) ? [3, 4] : [4, this._rebuildChildList(r)]
                );
              case 3:
                return e.sent(), [3, 6];
              case 4:
                return 0 == (2147483648 & r)
                  ? [3, 6]
                  : [
                      4,
                      s.utils.async.forEachParallel(
                        this.mChildren,
                        function (e, t) {
                          return t.performUpdates(r);
                        },
                        n.BaseItemManager.MAX_CONCURRENT_TASKS
                      ),
                    ];
              case 5:
                e.sent(), (e.label = 6);
              case 6:
                return (
                  this.mManager.eventItemUpdated.trigger({
                    item: this.asT,
                    flags: r,
                  }),
                  [2]
                );
            }
          });
        });
      }),
      (r.prototype.handleChangedItemProps = function () {}),
      Object.defineProperty(r.prototype, 'asT', {
        get: function () {
          return this;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (r.prototype.useItemPropsFromCache = function () {
        (this.mItemProps = this.mManager._getCachedItemProps(this.id)),
          this.handleChangedItemProps();
      }),
      (r.prototype.useCalculationFromCache = function () {
        this.mCalculation = this.mManager._getCachedItemCalculation(this.id);
      }),
      (r.prototype.useUserImageFromCache = function () {
        this.mUserImageUrl = this.mManager._getCachedItemUserImage(this.id);
      }),
      (r.prototype.useExtItemNumberFromCache = function () {
        this.mExtItemNumber = this.mManager._getCachedExtItemNumber(this.id);
      }),
      (r.prototype.getImageAttributeValue = function (e) {
        var t = e.indexOf('=');
        if (!(t < 0)) {
          var r = parseFloat(e.substr(t + 1));
          if (!isNaN(r)) return r;
        }
      }),
      (r.prototype.setParent = function (e, t) {
        var r;
        null != e &&
          ((r = this.mParent),
          (this.mParent = e),
          (this.mChildIndex = t),
          this.invalidateItemNumber(),
          null != r &&
            r !== this.mParent &&
            r.mChildren &&
            s.utils.array.remove(r.mChildren, this.asT));
      }),
      (r.prototype.invalidateItemNumber = function () {
        (this.mItemNumber = void 0), (this.mItemNumberArray = void 0);
        for (var e = 0, t = this.mChildren; e < t.length; e++)
          t[e].invalidateItemNumber();
      }),
      (r.prototype.collectItemsToFetch = function (i, a) {
        var s = { itemIds: new Array(), items: new Array() },
          o = function (e) {
            i(e) &&
              (null == a || a(e)) &&
              (s.itemIds.push(e.id), s.items.push(e));
            for (var t = 0, r = e.mChildren; t < r.length; t++) {
              var n = r[t];
              o(n);
            }
          };
        return o(this.asT), s;
      }),
      r);
    function r(e, t, r, n) {
      (this.mManager = e),
        (this.mParent = t),
        (this.mItem = n),
        (this.mChildren = new Array()),
        (this.mImageUrl = void 0),
        (this.mUserData = new s.utils.GroupedMap()),
        (this.mIsSelected = !1),
        (this.mChildIndex = r),
        this.useItemPropsFromCache(),
        this.useCalculationFromCache(),
        this.useUserImageFromCache(),
        this.useExtItemNumberFromCache(),
        this.mManager._registerItem(this.asT);
    }
    n.BaseItem = t;
  })((s = e.wcf || (e.wcf = {})).bsk || (s.bsk = {}));
})((egr = egr || {})),
  (function (e) {
    var o, a, r, t;
    function n() {
      return (null !== r && r.apply(this, arguments)) || this;
    }
    (o = e.wcf || (e.wcf = {})),
      (a = o.bsk || (o.bsk = {})),
      (r = a.BaseItem),
      __extends(n, r),
      Object.defineProperty(n.prototype, 'basket', {
        get: function () {
          return this.mManager;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (n.prototype.getSetArticle = function () {
        return this.internalGetSetArticle();
      }),
      (n.prototype.setTmText = function (i, a, s) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  (t = s),
                  o.utils.string.isNullOrEmpty(t)
                    ? [4, this.basket.session.session.getLocale()]
                    : [3, 2]
                );
              case 1:
                (r = e.sent()), (t = r.substr(0, 2)), (e.label = 2);
              case 2:
                return [
                  4,
                  this.mManager.session.basket.tmSetText(
                    null,
                    this.id,
                    i,
                    t,
                    a
                  ),
                ];
              case 3:
                return (
                  e.sent(),
                  (n = 2),
                  '10' === i && (n |= 1),
                  [2, this.updateItem(n)]
                );
            }
          });
        });
      }),
      (n.prototype.setUserImageUrl = function (n, i) {
        return (
          void 0 === i && (i = !0),
          __awaiter(this, void 0, void 0, function () {
            var t, r;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  return (
                    (t = n),
                    i && o.utils.string.isNotNullOrEmpty(t)
                      ? [4, this.mManager.session.session.importFile(t)]
                      : [3, 2]
                  );
                case 1:
                  (t = e.sent()), (e.label = 2);
                case 2:
                  return (
                    ((r = new o.eaiws.basket.ItemField()).columnId =
                      a.Basket.BASKET_COLUMN_ID_USER_IMAGE),
                    (r.itemId = this.id),
                    (r.data = null == t ? '' : t),
                    [4, this.mManager.session.basket.setItemFields([r])]
                  );
                case 3:
                  return e.sent(), [2, this.updateItem(64)];
              }
            });
          })
        );
      }),
      (n.prototype.setExtItemNumber = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  ((t = new o.eaiws.basket.ItemField()).columnId =
                    a.Basket.BASKET_COLUMN_ID_EXT_ITEM_NUMBER),
                  (t.itemId = this.id),
                  (t.data = r),
                  [4, this.mManager.session.basket.setItemFields([t])]
                );
              case 1:
                return e.sent(), [2, this.updateItem(128)];
            }
          });
        });
      }),
      (n.prototype.performUpdates = function (t) {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, r.prototype.performUpdates.call(this, t)];
              case 1:
                return e.sent(), [2, this.mManager._updateViewItems(this, t)];
            }
          });
        });
      }),
      (t = n),
      (a.BasketItem = t);
  })((egr = egr || {})),
  (function (e) {
    var o, t, a, r;
    function n(e, t, r, n) {
      var i = a.call(this, e, t, r, n) || this;
      return (
        (i.mCameraSetup = null),
        (i.mRequestStoredImage = !0),
        (i.mTaxInfoLock = new o.utils.async.Lock()),
        (i.mTaxInfo = null) == i.mOfmlUpdateState &&
          (i.mOfmlUpdateState = 'Unknown'),
        i
      );
    }
    (o = e.wcf || (e.wcf = {})),
      (t = o.bsk || (o.bsk = {})),
      (a = t.BasketItem),
      __extends(n, a),
      Object.defineProperty(n.prototype, 'isOfmlArticle', {
        get: function () {
          return !0;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(n.prototype, 'ofmlUpdateState', {
        get: function () {
          return this.mOfmlUpdateState;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (n.prototype.getMainArticle = function () {
        var e = this.mItem.getMainArticleId();
        if (null == e || e === this.id) return this;
        var t = this.mManager.getItemById(e);
        return null != t ? t : this;
      }),
      (n.prototype.isSubArticle = function () {
        var e = this.mItem.getMainArticleId();
        return null != e && e !== this.id;
      }),
      (n.prototype.getSubArticles = function (e) {
        var t = new Array();
        return this.internalGetSubArticles(e, t), t;
      }),
      (n.prototype.hasIndependentChildren = function () {
        if (
          null == this.mItem.subArticleIds ||
          0 === this.mItem.subArticleIds.length
        )
          return 0 < this.mChildren.length;
        for (var e = 0, t = this.mChildren; e < t.length; e++) {
          var r = t[e];
          if (!(r instanceof n)) return !0;
          if (!o.utils.array.contains(this.mItem.subArticleIds, r.id))
            return !0;
          if (r.hasIndependentChildren()) return !0;
        }
        return !1;
      }),
      (n.prototype.invalidateCalculation = function (e, t) {
        (this.mCompositeCalculation = void 0),
          a.prototype.invalidateCalculation.call(this, e, t);
      }),
      (n.prototype.updateWholeComposite = function (n) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  e.trys.push([0, , 5, 6]),
                  this.mManager._beginCaching(),
                  (t = this.getMainArticle()),
                  (r = 2147483647 & n),
                  0 == (1 & n)
                    ? [3, 2]
                    : [4, this.mManager._fetchEaiwsItems([t.id], !1, !0)]
                );
              case 1:
                e.sent(), (e.label = 2);
              case 2:
                return [4, t.updateItem(r)];
              case 3:
                return e.sent(), [4, t.updateSubArticles(r)];
              case 4:
                return e.sent(), [3, 6];
              case 5:
                return this.mManager._endCaching(), [7];
              case 6:
                return [2];
            }
          });
        });
      }),
      (n.prototype.setQuantity = function (n) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (t = this.getMainArticle()) != this
                  ? [2, t.setQuantity(n)]
                  : (((r = new o.eaiws.basket.ItemProperties()).article = new o.eaiws.basket.ArticleProperties()),
                    (r.article.quantity = n),
                    [
                      4,
                      this.mManager.session.basket.setItemProperties(
                        this.id,
                        r
                      ),
                    ]);
              case 1:
                return e.sent(), [4, this.updateWholeComposite(10)];
              case 2:
                return e.sent(), [2];
            }
          });
        });
      }),
      (n.prototype.getCompositeCalculation = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (t = this.getMainArticle()) != this
                  ? [2, t.getCompositeCalculation()]
                  : void 0 === this.mCompositeCalculation
                  ? [3, 1]
                  : [2, this.mCompositeCalculation];
              case 1:
                return [4, this.mManager._getCompositeCalculation(this)];
              case 2:
                return (r = e.sent()), [2, (this.mCompositeCalculation = r)];
            }
          });
        });
      }),
      (n.prototype.fetchOfmlUpdateState = function () {
        var e = this.getMainArticle();
        return e !== this
          ? e.fetchOfmlUpdateState()
          : this.mManager.fetchOfmlUpdateStates([this]);
      }),
      (n.prototype.getTaxInformation = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mTaxInfoLock.acquireLock()];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 4, 5]),
                  null != this.mTaxInfo
                    ? [2, this.mTaxInfo]
                    : [
                        4,
                        (r = this).mManager.session.basket.getTaxInformation(
                          this.id
                        ),
                      ]
                );
              case 3:
                return (r.mTaxInfo = e.sent()), [2, this.mTaxInfo];
              case 4:
                return t.unlock(), [7];
              case 5:
                return [2];
            }
          });
        });
      }),
      (n.SetShortText = function (e, t) {
        var r = new o.eaiws.basket.ItemProperties();
        return (
          (r.article = new o.eaiws.basket.ArticleProperties()),
          (r.article.shortText = t.trim()),
          e.setItemProperties(r, !0, !1)
        );
      }),
      (n.SetLongText = function (e, t) {
        var r = new o.eaiws.basket.ItemProperties();
        return (
          (r.article = new o.eaiws.basket.ArticleProperties()),
          (r.article.longText = t),
          e.setItemProperties(r, !1, !1)
        );
      }),
      (n.SetFeatureText = function (e, t) {
        var r = new o.eaiws.basket.ItemProperties();
        return (
          (r.article = new o.eaiws.basket.ArticleProperties()),
          (r.article.featureText = t),
          e.setItemProperties(r, !1, !1)
        );
      }),
      (n.SetManufacturerId = function (e, t) {
        var r = new o.eaiws.basket.ItemProperties();
        return (
          (r.article = new o.eaiws.basket.ArticleProperties()),
          (r.article.manufacturerId = t.replace(/[^a-zA-Z0-9]/g, '')),
          e.setItemProperties(r, !1, !1)
        );
      }),
      (n.SetSeriesId = function (e, t) {
        var r = new o.eaiws.basket.ItemProperties();
        return (
          (r.article = new o.eaiws.basket.ArticleProperties()),
          (r.article.seriesId = t.replace(/[^(a-zA-Z0-9_)]/g, '_')),
          e.setItemProperties(r, !1, !1)
        );
      }),
      (n.SetArticleNumber = function (e, t) {
        var r = new o.eaiws.basket.ItemProperties();
        return (
          (r.article = new o.eaiws.basket.ArticleProperties()),
          (r.article.baseArticleNumber = t),
          (r.article.finalArticleNumber = t),
          e.setItemProperties(r, !1, !1)
        );
      }),
      (n.prototype.performUpdates = function (e) {
        return (
          0 != (4 & e) && (this.mRequestStoredImage = !1),
          0 != (16 & e) && (this.mTaxInfo = null),
          0 != (32 & e) && (this.mConfigData = void 0),
          a.prototype.performUpdates.call(this, e)
        );
      }),
      (n.prototype.generateImageUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (this.mImageUrl = null) == this.mCameraSetup ||
                  this.mRequestStoredImage
                  ? [4, this.getStoredImage()]
                  : [3, 2];
              case 1:
                if (null != (t = e.sent()))
                  return (
                    this._setCameraSetup(this.getCameraSetupFromImage(t)),
                    (this.mImageUrl = t.url),
                    [2]
                  );
                e.label = 2;
              case 2:
                return [4, this.getGeneratedImage(this.mCameraSetup)];
              case 3:
                return (
                  (r = e.sent()),
                  o.utils.string.isNullOrEmpty(r)
                    ? [4, this.getCatalogImage()]
                    : ((this.mImageUrl = r), [2])
                );
              case 4:
                return (
                  (n = e.sent()),
                  o.utils.string.isNullOrEmpty(n) || (this.mImageUrl = n),
                  [2]
                );
            }
          });
        });
      }),
      (n.prototype.handleChangedItemProps = function () {
        null != this.mItemProps &&
          null != this.mItemProps.article &&
          null != this.mItemProps.article.ofmlUpdateState &&
          ((null != this.mOfmlUpdateState &&
            'UpToDate' !== this.mItemProps.article.ofmlUpdateState) ||
            (this.mOfmlUpdateState = this.mItemProps.article.ofmlUpdateState));
      }),
      (n.prototype._getCameraSetup = function () {
        return this.mCameraSetup;
      }),
      (n.prototype._setCameraSetup = function (e) {
        this.mCameraSetup = e;
      }),
      (n.prototype._shouldRequestStoredImage = function () {
        return this.mRequestStoredImage;
      }),
      (n.prototype._setOfmlUpdateState = function (e, t) {
        if (this.mOfmlUpdateState !== e) {
          (this.mOfmlUpdateState = e),
            t &&
              null != this.mItemProps &&
              null != this.mItemProps.article &&
              (this.mItemProps.article.ofmlUpdateState = e),
            this.mManager.eventOfmlUpdateStateChanged.trigger(this);
          for (var r = 0, n = this.getSubArticles(!1); r < n.length; r++)
            n[r]._setOfmlUpdateState(e, t);
        }
      }),
      (n.prototype._getCachedConfigData = function () {
        return this.mConfigData;
      }),
      (n.prototype._setCachedConfigData = function (e) {
        this.mConfigData = e;
      }),
      (n.prototype._getArticleData = function (a) {
        var s = this,
          e = this._getCachedArticleData(a);
        return null != e
          ? Promise.resolve(e)
          : this.mManager.session.basket
              .getArticleData(this.id, a)
              .then(function (e) {
                var t = a;
                null == t &&
                  (t = o.cf.MainArticleElement.DefaultGetArticleDataOptions),
                  null == s.mConfigData && (s.mConfigData = {});
                var r,
                  n = s.mConfigData.articleDataOptions,
                  i = s.mConfigData.articleData;
                return (
                  null == n || null == i
                    ? ((r = new o.eaiws.basket.GetArticleDataOptions()),
                      Object.assign(r, t),
                      (s.mConfigData.articleData = e),
                      (s.mConfigData.articleDataOptions = r))
                    : null != e &&
                      (t.noProperties ||
                        ((n.noProperties = !1),
                        (i.properties = e.properties),
                        (i.propertyClasses = e.propertyClasses)),
                      t.fetchCatalogIcon &&
                        ((n.fetchCatalogIcon = !0),
                        (i.catalogIcon = e.catalogIcon)),
                      t.fetchCatalogImage &&
                        ((n.fetchCatalogImage = !0),
                        (i.catalogImage = e.catalogImage))),
                  e
                );
              });
      }),
      (n.prototype.updateSubArticles = function (r) {
        var n = this,
          e = this.getSubArticles(!1);
        return o.utils.async
          .forEachParallel(
            e,
            function (e, t) {
              return __awaiter(n, void 0, void 0, function () {
                return __generator(this, function (e) {
                  switch (e.label) {
                    case 0:
                      return [4, t.updateItem(r)];
                    case 1:
                      return e.sent(), [4, t.updateSubArticles(r)];
                    case 2:
                      return e.sent(), [2];
                  }
                });
              });
            },
            t.BaseItemManager.MAX_CONCURRENT_TASKS
          )
          .then(function () {});
      }),
      (n.prototype.internalGetSubArticles = function (e, t) {
        if (null != this.mItem.subArticleIds)
          for (var r = 0, n = this.mItem.subArticleIds; r < n.length; r++) {
            var i = n[r],
              a = this.mManager.getItemById(i);
            null != a
              ? (t.push(a), e && a.internalGetSubArticles(e, t))
              : o.utils.Log.warn('Unknown sub article: ' + i);
          }
      }),
      (n.prototype._getCachedArticleData = function (e) {
        var t = e;
        if (
          (null == t &&
            (t = o.cf.MainArticleElement.DefaultGetArticleDataOptions),
          null != this.mConfigData &&
            null != this.mConfigData.articleDataOptions)
        ) {
          var r = this.mConfigData.articleDataOptions;
          if (
            null != r &&
            (!r.noProperties || t.noProperties) &&
            (r.fetchCatalogIcon || !t.fetchCatalogIcon) &&
            (r.fetchCatalogImage || !t.fetchCatalogImage)
          )
            return this.mConfigData.articleData;
        }
      }),
      (r = n),
      (t.ArticleItem = r);
  })((egr = egr || {})),
  (function (e) {
    var c, i, t;
    function r(e) {
      (this.eventSelectionChanged = new c.utils.ListenableEvent(this)),
        (this.eventHeaderCalculationChanged = new c.utils.ListenableEvent(
          this
        )),
        (this.eventItemCreated = new c.utils.ListenableEvent(this)),
        (this.eventItemDisposed = new c.utils.ListenableEvent(this)),
        (this.eventItemUpdated = new c.utils.ListenableEvent(this)),
        (this.mSession = e),
        (this.mRoot = void 0),
        (this.mItemMap = new Map()),
        (this.mSelection = new Array()),
        (this.mSelectionChanged = !1),
        (this.mSelectionChangeDepth = 0),
        (this.mCacheDepth = 0),
        (this.mItemUpdateDepth = 0),
        (this.mItemUpdatePromise = null),
        (this.mItemUpdatePromiseResolve = null),
        (this.mPropsCache = new Map()),
        (this.mEaiwsItemCache = new Map()),
        (this.mCalculationCache = new Map()),
        (this.mUserImageCache = new Map()),
        (this.mExtItemNumberCache = new Map()),
        (this.mHeaderCalculation = void 0),
        (this._fetchItemPropertiesLock = new c.utils.async.Lock()),
        (this._fetchCalculationsLock = new c.utils.async.Lock()),
        (this._fetchUserImagesLock = new c.utils.async.Lock()),
        (this._fetchExtItemNumbersLock = new c.utils.async.Lock()),
        (this._deletedItemsCache = new Map());
    }
    (c = e.wcf || (e.wcf = {})),
      (i = c.bsk || (c.bsk = {})),
      Object.defineProperty(r.prototype, 'root', {
        get: function () {
          return this.mRoot;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'session', {
        get: function () {
          return this.mSession;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'selection', {
        get: function () {
          return this.mSelection;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (r.prototype.getHeaderCalculation = function () {
        var e,
          r = this,
          n = this._getPricingProcedure();
        return null == n
          ? c.utils.rejectError(
              c.utils.ERR_INVALID_STATE,
              'no active pricing procedure'
            )
          : null != this.mHeaderCalculation
          ? Promise.resolve(this.mHeaderCalculation)
          : (null != this.mViewId &&
              ((e = new c.eaiws.basket.GetPriceCalculationSheetOptions()).viewId = this.mViewId),
            this.mSession.basket
              .getPriceCalculationSheet([''], n.name, e)
              .then(function (e) {
                var t = new c.eaiws.basket.CalculationSheetInfo(n, e);
                return (r.mHeaderCalculation = t);
              }));
      }),
      (r.prototype.invalidateHeaderCalculation = function () {
        (this.mHeaderCalculation = void 0),
          this.eventHeaderCalculationChanged.trigger();
      }),
      (r.prototype.getItemById = function (e) {
        var t = this.mItemMap.get(e);
        return null != t ? t : null;
      }),
      (r.prototype.setSelection = function (e) {
        var t = !1;
        if (0 < this.mSelection.length) {
          for (var r = 0, n = this.mSelection; r < n.length; r++)
            (i = n[r])._setIsSelected(!1);
          (this.mSelection = new Array()), (t = !0);
        }
        if (null != e && 0 < e.length) {
          for (var i, a = 0, s = e; a < s.length; a++)
            (i = s[a]).isDisposed ||
              i.isSelected ||
              (this.mSelection.push(i), i._setIsSelected(!0));
          t = !0;
        }
        return t && this.selectionChanged(), t;
      }),
      (r.prototype.addToSelection = function (e) {
        return (
          null != e &&
          !e.isSelected &&
          !e.isDisposed &&
          (this.mSelection.push(e),
          e._setIsSelected(!0),
          this.selectionChanged(),
          !0)
        );
      }),
      (r.prototype.removeFromSelection = function (e) {
        return !(
          null == e ||
          !e.isSelected ||
          !c.utils.array.remove(this.mSelection, e) ||
          (e._setIsSelected(!1), this.selectionChanged(), 0)
        );
      }),
      (r.prototype.beginSelectionChange = function () {
        this.mSelectionChangeDepth++;
      }),
      (r.prototype.endSelectionChange = function () {
        this.mSelectionChangeDepth--,
          this.mSelectionChangeDepth <= 0 &&
            ((this.mSelectionChangeDepth = 0),
            this.mSelectionChanged && this.selectionChanged());
      }),
      (r.prototype.waitUntilItemsUpdated = function () {
        return null == this.mItemUpdatePromise
          ? Promise.resolve()
          : this.mItemUpdatePromise;
      }),
      (r.prototype._getViewId = function () {
        return this.mViewId;
      }),
      (r.prototype._registerItem = function (e) {
        null != e && null != this.mItemMap && this.mItemMap.set(e.id, e);
      }),
      (r.prototype._deregisterItem = function (e) {
        null != e &&
          null != this.mItemMap &&
          (this.mItemMap.delete(e.id), this.removeFromSelection(e));
      }),
      (r.prototype._createItem = function (n, i, a, s) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (c.utils.string.isNullOrEmpty(n))
                  throw new Error(c.utils.ERR_INVALID_ARGUMENT);
                e.label = 1;
              case 1:
                return (
                  e.trys.push([1, , 4, 5]),
                  this._beginItemUpdate(),
                  this._beginCaching(),
                  [4, this._fetchEaiwsItems([n], !0, !1)]
                );
              case 2:
                if ((e.sent(), null == (t = this._getCachedEaiwsItem(n))))
                  throw new Error('Failed to get eaiws item: ' + n);
                return [4, (r = this.createItem(i, a, t))._rebuildChildList(0)];
              case 3:
                return e.sent(), s && this.eventItemCreated.trigger(r), [2, r];
              case 4:
                return this._endCaching(), this._endItemUpdate(), [7];
              case 5:
                return [2];
            }
          });
        });
      }),
      (r.prototype._getEaiwsItem = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (c.utils.string.isNullOrEmpty(r))
                  throw new Error(c.utils.ERR_INVALID_ARGUMENT);
                e.label = 1;
              case 1:
                return (
                  e.trys.push([1, , 3, 4]),
                  this._beginCaching(),
                  [4, this._fetchEaiwsItems([r], !1, !1)]
                );
              case 2:
                if ((e.sent(), null == (t = this._getCachedEaiwsItem(r))))
                  throw new Error('Failed to get eaiws item: ' + r);
                return [2, t];
              case 3:
                return this._endCaching(), [7];
              case 4:
                return [2];
            }
          });
        });
      }),
      (r.prototype._fetchEaiwsItems = function (e, t, r) {
        var i = this;
        if (!this._isCaching())
          return c.utils.rejectError(
            c.utils.ERR_INVALID_STATE,
            'caching not enabled'
          );
        var n = this.getUncachedItemIds(e, this.mEaiwsItemCache);
        if (n.length <= 0) return Promise.resolve();
        var a = new c.eaiws.basket.GetAllItemsOptions();
        return (
          (a.setArticleIds = !0),
          (a.geometryIds = !0),
          (a.subItems = t),
          (a.wholeComposite = r),
          null != this.mViewId && (a.viewId = this.mViewId),
          this.mSession.basket.getAllItems(n, a).then(function (e) {
            for (var t = 0, r = e; t < r.length; t++) {
              var n = r[t];
              i._addEaiwsItemToCache(n);
            }
          })
        );
      }),
      (r.prototype._getCachedEaiwsItem = function (e) {
        return this.mEaiwsItemCache.get(e);
      }),
      (r.prototype._getItemProps = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (c.utils.string.isNullOrEmpty(r))
                  throw new Error(c.utils.ERR_INVALID_ARGUMENT);
                e.label = 1;
              case 1:
                return (
                  e.trys.push([1, , 3, 4]),
                  this._beginCaching(),
                  [4, this._fetchItemProps([r], !1, !1)]
                );
              case 2:
                if ((e.sent(), null == (t = this._getCachedItemProps(r))))
                  throw new Error('Failed to get item properties: ' + r);
                return [2, t];
              case 3:
                return this._endCaching(), [7];
              case 4:
                return [2];
            }
          });
        });
      }),
      (r.prototype._fetchItemProps = function (e, t, r) {
        var i = this;
        if (!this._isCaching())
          return c.utils.rejectError(
            c.utils.ERR_INVALID_STATE,
            'caching not enabled'
          );
        var n = this.getUncachedItemIds(e, this.mPropsCache);
        if (n.length <= 0) return Promise.resolve();
        var a,
          s = new c.eaiws.basket.GetItemPropertiesOptions();
        return (
          (s.subItems = t),
          (s.wholeComposite = r),
          null != this.mViewId &&
            ((s.viewId = this.mViewId),
            null != (a = this._getPricingProcedure()) &&
              ((s.priceInfo = !0), (s.pricingProcedureName = a.name))),
          this.mSession.basket.getItemProperties(n, s).then(function (e) {
            for (var t = 0, r = e; t < r.length; t++) {
              var n = r[t];
              null != n.itemId && i.mPropsCache.set(n.itemId, n);
            }
          })
        );
      }),
      (r.prototype._getCachedItemProps = function (e) {
        return this.mPropsCache.get(e);
      }),
      (r.prototype._getItemCalculation = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (c.utils.string.isNullOrEmpty(r))
                  throw new Error(c.utils.ERR_INVALID_ARGUMENT);
                e.label = 1;
              case 1:
                return (
                  e.trys.push([1, , 3, 4]),
                  this._beginCaching(),
                  [4, this._fetchItemCalculations([r], !1, !1)]
                );
              case 2:
                if ((e.sent(), null == (t = this._getCachedItemCalculation(r))))
                  throw new Error('Failed to get item calculation: ' + r);
                return [2, t];
              case 3:
                return this._endCaching(), [7];
              case 4:
                return [2];
            }
          });
        });
      }),
      (r.prototype._fetchItemCalculations = function (e, t, r) {
        var i = this;
        if (!this._isCaching())
          return c.utils.rejectError(
            c.utils.ERR_INVALID_STATE,
            'caching not enabled'
          );
        var a = this._getPricingProcedure();
        if (null == a)
          return c.utils.rejectError(
            c.utils.ERR_INVALID_STATE,
            'no active pricing procedure'
          );
        var n = this.getUncachedItemIds(e, this.mCalculationCache);
        if (n.length <= 0) return Promise.resolve();
        var s = new c.eaiws.basket.GetPriceCalculationSheetOptions();
        return (
          (s.subItems = t),
          (s.wholeComposite = r),
          null != this.mViewId && (s.viewId = this.mViewId),
          this.mSession.basket
            .getPriceCalculationSheets(n, a.name, s)
            .then(function (e) {
              for (var t = 0, r = e; t < r.length; t++) {
                var n = r[t];
                i.mCalculationCache.set(
                  n.id,
                  new c.eaiws.basket.CalculationSheetInfo(a, n.sheet)
                );
              }
            })
        );
      }),
      (r.prototype._getCompositeCalculation = function (a) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == (t = this._getPricingProcedure()))
                  throw c.utils.newError(
                    c.utils.ERR_INVALID_STATE,
                    'no active pricing procedure'
                  );
                return (
                  ((r = new c.eaiws.basket.GetPriceCalculationSheetOptions()).wholeComposite = !0),
                  null != this.mViewId && (r.viewId = this.mViewId),
                  [
                    4,
                    this.mSession.basket.getPriceCalculationSheet(
                      [a.id],
                      t.name,
                      r
                    ),
                  ]
                );
              case 1:
                return null != (n = e.sent()).quantity
                  ? [3, 3]
                  : [4, a.getCalculation()];
              case 2:
                (i = e.sent()), (n.quantity = i.sheet.quantity), (e.label = 3);
              case 3:
                return [2, new c.eaiws.basket.CalculationSheetInfo(t, n)];
            }
          });
        });
      }),
      (r.prototype._getCachedItemCalculation = function (e) {
        return this.mCalculationCache.get(e);
      }),
      (r.prototype._getItemUserImage = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (c.utils.string.isNullOrEmpty(r))
                  throw new Error(c.utils.ERR_INVALID_ARGUMENT);
                e.label = 1;
              case 1:
                return (
                  e.trys.push([1, , 3, 4]),
                  this._beginCaching(),
                  [4, this._fetchItemUserImages([r], !1, !1)]
                );
              case 2:
                if (
                  (e.sent(), void 0 === (t = this._getCachedItemUserImage(r)))
                )
                  throw new Error('Failed to get item user image: ' + r);
                return [2, t];
              case 3:
                return this._endCaching(), [7];
              case 4:
                return [2];
            }
          });
        });
      }),
      (r.prototype._fetchItemUserImages = function (e, t, r) {
        var o = this;
        if (!this._isCaching())
          return c.utils.rejectError(
            c.utils.ERR_INVALID_STATE,
            'caching not enabled'
          );
        var l = this.getUncachedItemIds(e, this.mUserImageCache);
        if (l.length <= 0) return Promise.resolve();
        var n = new c.eaiws.basket.GetItemFieldsOptions();
        return (
          (n.useDefault = !1),
          (n.resolveURI = !0),
          (n.subItems = t),
          (n.wholeComposite = r),
          null != this.mViewId && (n.viewId = this.mViewId),
          this.mSession.basket
            .getItemFields(l, [i.Basket.BASKET_COLUMN_ID_USER_IMAGE], n)
            .then(function (e) {
              for (var t = 0, r = l; t < r.length; t++) {
                var n = r[t];
                o.mUserImageCache.set(n, null);
              }
              for (var i = 0, a = e; i < a.length; i++) {
                var s = a[i];
                c.utils.string.isNullOrEmpty(s.data) ||
                s.data.startsWith('imp:')
                  ? o.mUserImageCache.set(s.itemId, null)
                  : o.mUserImageCache.set(s.itemId, s.data);
              }
            })
        );
      }),
      (r.prototype._getCachedItemUserImage = function (e) {
        return this.mUserImageCache.get(e);
      }),
      (r.prototype._getExtItemNumber = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (c.utils.string.isNullOrEmpty(r))
                  throw new Error(c.utils.ERR_INVALID_ARGUMENT);
                e.label = 1;
              case 1:
                return (
                  e.trys.push([1, , 3, 4]),
                  this._beginCaching(),
                  [4, this._fetchExtItemNumbers([r], !1, !1)]
                );
              case 2:
                if (
                  (e.sent(), void 0 === (t = this._getCachedExtItemNumber(r)))
                )
                  throw new Error('Failed to get external item number: ' + r);
                return [2, t];
              case 3:
                return this._endCaching(), [7];
              case 4:
                return [2];
            }
          });
        });
      }),
      (r.prototype._fetchExtItemNumbers = function (e, t, r) {
        var o = this;
        if (!this._isCaching())
          return c.utils.rejectError(
            c.utils.ERR_INVALID_STATE,
            'caching not enabled'
          );
        var l = this.getUncachedItemIds(e, this.mExtItemNumberCache);
        if (l.length <= 0) return Promise.resolve();
        var n = new c.eaiws.basket.GetItemFieldsOptions();
        return (
          (n.useDefault = !1),
          (n.subItems = t),
          (n.wholeComposite = r),
          null != this.mViewId && (n.viewId = this.mViewId),
          this.mSession.basket
            .getItemFields(l, [i.Basket.BASKET_COLUMN_ID_EXT_ITEM_NUMBER], n)
            .then(function (e) {
              for (var t = 0, r = l; t < r.length; t++) {
                var n = r[t];
                o.mExtItemNumberCache.set(n, null);
              }
              for (var i = 0, a = e; i < a.length; i++) {
                var s = a[i];
                o.mExtItemNumberCache.set(s.itemId, s.data);
              }
            })
        );
      }),
      (r.prototype._getCachedExtItemNumber = function (e) {
        return this.mExtItemNumberCache.get(e);
      }),
      (r.prototype._beginCaching = function () {
        this.mCacheDepth++;
      }),
      (r.prototype._endCaching = function () {
        this.mCacheDepth--,
          this.mCacheDepth <= 0 &&
            ((this.mCacheDepth = 0),
            (this.mPropsCache = new Map()),
            (this.mEaiwsItemCache = new Map()),
            (this.mCalculationCache = new Map()),
            (this.mUserImageCache = new Map()),
            (this.mExtItemNumberCache = new Map()),
            0 < this._deletedItemsCache.size &&
              (this._deletedItemsCache.forEach(function (e) {
                return e._dispose();
              }),
              (this._deletedItemsCache = new Map())));
      }),
      (r.prototype._isCaching = function () {
        return 0 < this.mCacheDepth;
      }),
      (r.prototype._addEaiwsItemToCache = function (e) {
        this._isCaching() && null != e && this.mEaiwsItemCache.set(e.itemId, e);
      }),
      (r.prototype._addItemPropsToCache = function (e) {
        this._isCaching() &&
          null != e &&
          null != e.itemId &&
          this.mPropsCache.set(e.itemId, e);
      }),
      (r.prototype._addCalculationInfoToCache = function (e, t) {
        this._isCaching() &&
          null != t &&
          null != e &&
          this.mCalculationCache.set(e, t);
      }),
      (r.prototype._beginItemUpdate = function () {
        var t = this;
        this.mItemUpdateDepth++,
          1 === this.mItemUpdateDepth &&
            (this.mItemUpdatePromise = new Promise(function (e) {
              t.mItemUpdatePromiseResolve = e;
            }));
      }),
      (r.prototype._endItemUpdate = function () {
        this.mItemUpdateDepth--,
          this.mItemUpdateDepth <= 0 &&
            ((this.mItemUpdateDepth = 0),
            (this.mItemUpdatePromise = null) !=
              this.mItemUpdatePromiseResolve &&
              (this.mItemUpdatePromiseResolve(),
              (this.mItemUpdatePromiseResolve = null)));
      }),
      (r.prototype.internalClear = function () {
        null != this.mRoot &&
          ((this.mItemMap = void 0),
          this.mRoot._dispose(),
          (this.mRoot = void 0)),
          (this.mHeaderCalculation = void 0),
          (this.mItemMap = new Map()),
          (this.mSelection = new Array());
      }),
      (r.prototype.loadRootFolder = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  e.trys.push([0, , 3, 4]),
                  this._beginCaching(),
                  ((t = new c.eaiws.basket.GetAllItemsOptions()).setArticleIds = !0),
                  (t.geometryIds = !0),
                  null != this.mViewId && (t.viewId = this.mViewId),
                  [4, this.mSession.basket.getAllItems(void 0, t)]
                );
              case 1:
                for (r = e.sent(), n = 0, i = r; n < i.length; n++)
                  (a = i[n]), this._addEaiwsItemToCache(a);
                if (0 === r.length) throw new Error('Failed to create root.');
                return [4, (s = this)._createItem(r[0].itemId, null, 0, !1)];
              case 2:
                return (
                  (s.mRoot = e.sent()),
                  this.eventItemCreated.trigger(this.mRoot),
                  [3, 4]
                );
              case 3:
                return this._endCaching(), [7];
              case 4:
                return [2];
            }
          });
        });
      }),
      (r.prototype.selectionChanged = function () {
        (this.mSelectionChanged = !0),
          0 === this.mSelectionChangeDepth &&
            ((this.mSelectionChanged = !1),
            this.eventSelectionChanged.trigger());
      }),
      (r.prototype.getUncachedItemIds = function (e, t) {
        for (var r = new Array(), n = 0, i = e; n < i.length; n++) {
          var a = i[n];
          void 0 === t.get(a) && r.push(a);
        }
        return r;
      }),
      (r.MAX_CONCURRENT_TASKS = 10),
      (t = r),
      (i.BaseItemManager = t);
  })((egr = egr || {})),
  (function (e) {
    var S, y, n, t;
    function E(e, t) {
      var r = n.call(this, e) || this;
      return (
        (r.eventOfmlArticleUpdated = new S.utils.ListenableEvent(r)),
        (r.eventOfmlUpdateStateChanged = new S.utils.ListenableEvent(r)),
        (r.eventModified = new S.utils.ListenableEvent(r)),
        (r.onNotifyModified = function () {
          r.eventModified.trigger();
        }),
        (r.mArticleConf = new y.cfg.ArticleConfigurationImpl(r)),
        (r.mCalcManager = new y.CalculationManager(r)),
        (r.mViews = new Array()),
        null != t
          ? t.session === e
            ? (r.mProjectInfo = t)
            : (S.utils.Log.warn(
                'pProjectInfo parameter will be ignored because its using a different session instance.'
              ),
              (r.mProjectInfo = new y.ProjectInfo(e)))
          : (r.mProjectInfo = new y.ProjectInfo(e)),
        (r.mGeneratedImageResolution = 512),
        (r.mGeneratedImageOptions = S.utils.array.clone(
          E.DEFAULT_GENERATED_IMAGE_OPTIONS
        )),
        r.eventHeaderCalculationChanged.addListener(r.onNotifyModified),
        r.eventItemCreated.addListener(r.onNotifyModified),
        r.eventItemDisposed.addListener(r.onNotifyModified),
        r.eventItemUpdated.addListener(r.onNotifyModified),
        r.eventOfmlArticleUpdated.addListener(r.onNotifyModified),
        r.articleConfiguration.eventBasketChanged.addListener(
          r.onNotifyModified
        ),
        r.calculation.eventTaxSchemeChanged.addListener(r.onNotifyModified),
        r.calculation.eventCurrencyChanged.addListener(r.onNotifyModified),
        r.projectInfo.eventAddressDataChanged.addListener(r.onNotifyModified),
        r.projectInfo.eventAppDataChanged.addListener(r.onNotifyModified),
        r.projectInfo.eventContactDataChanged.addListener(r.onNotifyModified),
        r.projectInfo.eventSettingsChanged.addListener(r.onNotifyModified),
        r.projectInfo.eventProjectDataChanged.addListener(r.onNotifyModified),
        r
      );
    }
    (S = e.wcf || (e.wcf = {})),
      (y = S.bsk || (S.bsk = {})),
      (n = y.BaseItemManager),
      __extends(E, n),
      Object.defineProperty(E.prototype, 'articleConfiguration', {
        get: function () {
          return this.mArticleConf;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(E.prototype, 'calculation', {
        get: function () {
          return this.mCalcManager;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(E.prototype, 'views', {
        get: function () {
          return this.mViews;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(E.prototype, 'isValid', {
        get: function () {
          return this.mSession.isValid && null != this.mRoot;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(E.prototype, 'projectInfo', {
        get: function () {
          return this.mProjectInfo;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(E.prototype, 'generatedImageResolution', {
        get: function () {
          return this.mGeneratedImageResolution;
        },
        set: function (e) {
          this.setGeneratedImageResolution(e);
        },
        enumerable: !1,
        configurable: !0,
      }),
      (E.prototype.loadFromSession = function (i) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  null != this.mRoot && this.clear(),
                  (t = !1),
                  null != i &&
                    null != i.checkForPreConfigurationItem &&
                    (t = i.checkForPreConfigurationItem),
                  (r = this.mArticleConf.loadFromSession(t)),
                  (n = new Array()).push(r),
                  n.push(this.mCalcManager._loadFromSession()),
                  n.push(this.prepareBasketColumns()),
                  [4, Promise.all(n)]
                );
              case 1:
                return e.sent(), [4, this.loadRootFolder()];
              case 2:
                return e.sent(), [4, r];
              case 3:
                return [2, { restoreArticlePreConfiguration: e.sent() }];
            }
          });
        });
      }),
      (E.prototype.updateSessionLanguage = function () {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  this.mCalcManager._notifyTaxSchemeChanged(),
                  null != this.mArticleConf.articleManager &&
                    this.mArticleConf.articleManager.resetCachedArticleInfos(
                      !0
                    ),
                  [4, this.mRoot.updateItem(-85)]
                );
              case 1:
                return e.sent(), [2];
            }
          });
        });
      }),
      (E.prototype.clear = function () {
        for (var e = 0, t = this.mViews; e < t.length; e++) t[e]._dispose();
        this.mArticleConf.clear(),
          this.mCalcManager._clear(),
          this.mProjectInfo.clear(),
          (this.mViews = new Array()),
          this.internalClear();
      }),
      (E.prototype.addView = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, y.View._CreateView(this, r)];
              case 1:
                return (t = e.sent()), this.mViews.push(t), [2, t];
            }
          });
        });
      }),
      (E.prototype.removeView = function (e) {
        S.utils.array.remove(this.mViews, e) && e._dispose();
      }),
      (E.prototype.insertArticle = function (a) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == a) throw new Error(S.utils.ERR_INVALID_ARGUMENT);
                return (
                  ((t = new S.eaiws.basket.InsertInfo()).articlePackageId =
                    a.articlePackageId),
                  (t.baseArticleNumber = a.baseArticleNumber),
                  (t.catalogId = a.catalogId),
                  (t.catalogPackageId = a.catalogPackageId),
                  (t.variantCode = a.variantCode),
                  (r = this.getInsertPosition()),
                  [
                    4,
                    this.mSession.basket.insertOFMLArticle(
                      r.parent.id,
                      r.beforeItemId,
                      t
                    ),
                  ]
                );
              case 1:
                if (((n = e.sent()), S.utils.string.isNullOrEmpty(n)))
                  throw new Error(
                    'Failed to insert article ' + a.baseArticleNumber
                  );
                return [
                  4,
                  this.updateParentsAfterInsertOrRemove([r.parent], [n]),
                ];
              case 2:
                if ((e.sent(), null == (i = this.getItemById(n))))
                  throw new Error(
                    'Failed to insert article ' + a.baseArticleNumber
                  );
                return [2, i];
            }
          });
        });
      }),
      (E.prototype.insertContainerItem = function (g) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c, u, h, m, d, p;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if ('Container' !== g.type)
                  throw new Error('Invalid catalog item type.');
                if ((t = null) != g.resources)
                  for (r = 0, n = g.resources; r < n.length; r++)
                    if ('XCF:PEC' === (i = n[r]).type) {
                      t = i.value;
                      break;
                    }
                if (S.utils.string.isNullOrEmpty(t))
                  throw new Error(
                    'Catalog item does not have XCF:PEC resource.'
                  );
                return (
                  (a = this.getInsertPosition()),
                  ((s = new S.eaiws.basket.PasteContainerOptions()).setArticleIds = !0),
                  (s.geometryIds = !0),
                  (s.ignoreComposableGeometries = !0),
                  [
                    4,
                    this.mSession.basket.pasteContainer(
                      a.parent.id,
                      a.beforeItemId,
                      t,
                      s
                    ),
                  ]
                );
              case 1:
                if (null == (o = e.sent()))
                  throw new Error('Failed to insert container.');
                e.label = 2;
              case 2:
                for (
                  e.trys.push([2, , 4, 5]),
                    this._beginItemUpdate(),
                    this._beginCaching(),
                    l = 0,
                    c = o.items;
                  l < c.length;
                  l++
                )
                  (p = c[l]), this._addEaiwsItemToCache(p);
                return [4, this.updateParentsAfterInsertOrRemove([a.parent])];
              case 3:
                for (
                  e.sent(), u = new Array(), h = 0, m = o.items;
                  h < m.length;
                  h++
                )
                  (d = m[h]),
                    null != (p = this.getItemById(d.itemId)) && u.push(p);
                return [2, u];
              case 4:
                return this._endCaching(), this._endItemUpdate(), [7];
              case 5:
                return [2];
            }
          });
        });
      }),
      (E.prototype.insertFolder = function (i) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  (t = this.getInsertPosition()),
                  [
                    4,
                    this.mSession.basket.insertFolder(
                      t.parent.id,
                      t.beforeItemId,
                      i
                    ),
                  ]
                );
              case 1:
                if (((r = e.sent()), S.utils.string.isNullOrEmpty(r)))
                  throw new Error('Failed to insert folder.');
                return [
                  4,
                  this.updateParentsAfterInsertOrRemove([t.parent], [r]),
                ];
              case 2:
                if ((e.sent(), null == (n = this.getItemById(r))))
                  throw new Error('Failed to insert folder.');
                return [2, n];
            }
          });
        });
      }),
      (E.prototype.insertSetArticle = function (i) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  (t = this.getInsertPosition(null, null, !0)),
                  [
                    4,
                    this.mSession.basket.insertFolder(
                      t.parent.id,
                      t.beforeItemId,
                      i
                    ),
                  ]
                );
              case 1:
                if (((r = e.sent()), S.utils.string.isNullOrEmpty(r)))
                  throw new Error('Failed to insert set article.');
                return [4, this.mSession.basket.convertToSetArticle(r)];
              case 2:
                return (
                  (r = e.sent()),
                  [4, this.updateParentsAfterInsertOrRemove([t.parent], [r])]
                );
              case 3:
                if ((e.sent(), null == (n = this.getItemById(r))))
                  throw new Error('Failed to insert set article.');
                return [2, n];
            }
          });
        });
      }),
      (E.prototype.insertUserArticle = function (i) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  (t = this.getInsertPosition()),
                  [
                    4,
                    this.mSession.basket.insertUserArticle(
                      t.parent.id,
                      t.beforeItemId,
                      i
                    ),
                  ]
                );
              case 1:
                if (((r = e.sent()), S.utils.string.isNullOrEmpty(r)))
                  throw new Error('Failed to insert user article.');
                return [
                  4,
                  this.updateParentsAfterInsertOrRemove([t.parent], [r]),
                ];
              case 2:
                if ((e.sent(), null == (n = this.getItemById(r))))
                  throw new Error('Failed to insert user article.');
                return [2, n];
            }
          });
        });
      }),
      (E.prototype.insertTextItem = function (i) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  (t = this.getInsertPosition()),
                  [
                    4,
                    this.mSession.basket.insertTextItem(
                      t.parent.id,
                      t.beforeItemId,
                      i
                    ),
                  ]
                );
              case 1:
                if (((r = e.sent()), S.utils.string.isNullOrEmpty(r)))
                  throw new Error('Failed to insert text item.');
                return [
                  4,
                  this.updateParentsAfterInsertOrRemove([t.parent], [r]),
                ];
              case 2:
                if ((e.sent(), null == (n = this.getItemById(r))))
                  throw new Error('Failed to insert text item.');
                return [2, n];
            }
          });
        });
      }),
      (E.prototype.deleteItems = function (l, c) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (0 === l.length) return [2];
                for (
                  t = { wholeComposite: !0, children: !0 },
                    Object.assign(t, c),
                    r = this.getParentsToUpdateAfterRemove(
                      l,
                      t.wholeComposite,
                      t.children
                    ),
                    (n = new S.eaiws.basket.DeleteItemsOptions()).wholeComposite =
                      t.wholeComposite,
                    n.subItems = t.children,
                    i = new Array(),
                    a = 0,
                    s = l;
                  a < s.length;
                  a++
                )
                  (o = s[a]), i.push(o.id);
                return [4, this.mSession.basket.deleteItems(i, n)];
              case 1:
                return e.sent(), [4, this.updateParentsAfterInsertOrRemove(r)];
              case 2:
                return e.sent(), [2];
            }
          });
        });
      }),
      (E.prototype.copyItems = function (u, h) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                for (
                  t = { wholeComposite: !0, children: !0, cut: !1 },
                    Object.assign(t, h),
                    (r = new S.eaiws.basket.OperationMode()).mainArticles =
                      t.wholeComposite,
                    r.subPositions = t.children,
                    (n = new S.eaiws.basket.CopyOptions()).cut = t.cut,
                    t.cut &&
                      (i = this.getParentsToUpdateAfterRemove(
                        u,
                        t.wholeComposite,
                        t.children
                      )),
                    a = new Array(),
                    s = 0,
                    o = u;
                  s < o.length;
                  s++
                )
                  (l = o[s]), a.push(l.id);
                return [4, this.mSession.basket.copy(a, r, null, n)];
              case 1:
                return (
                  (c = e.sent()),
                  t.cut ? [4, this.updateParentsAfterInsertOrRemove(i)] : [3, 3]
                );
              case 2:
                e.sent(), (e.label = 3);
              case 3:
                return [2, c];
            }
          });
        });
      }),
      (E.prototype.pasteItems = function (m, d) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c, u, h;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  (t = { parent: null, beforeItem: null }),
                  Object.assign(t, d),
                  (r = this.getInsertPosition(t.parent, t.beforeItem)),
                  [
                    4,
                    this.mSession.basket.paste(r.parent.id, r.beforeItemId, m),
                  ]
                );
              case 1:
                return (
                  (n = e.sent()),
                  [4, this.updateParentsAfterInsertOrRemove([r.parent], n)]
                );
              case 2:
                for (e.sent(), i = new Array(), a = 0, s = n; a < s.length; a++)
                  (u = s[a]), null != (h = this.getItemById(u)) && i.push(h);
                return null ==
                  (o =
                    r.parent instanceof y.SetArticleItem
                      ? r.parent
                      : r.parent.getSetArticle())
                  ? [3, 5]
                  : [4, this.addItemsToCurrentSet(i)];
              case 3:
                return (
                  e.sent(), [4, this.updateParentsAfterInsertOrRemove([o])]
                );
              case 4:
                for (e.sent(), i = new Array(), l = 0, c = n; l < c.length; l++)
                  (u = c[l]), null != (h = this.getItemById(u)) && i.push(h);
                e.label = 5;
              case 5:
                return [2, i];
            }
          });
        });
      }),
      (E.prototype.relocateItems = function (c, u, h, m) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return 0 === c.length
                  ? [2, []]
                  : ((t = { reorder: !1, copy: !1 }),
                    Object.assign(t, m),
                    t.copy ? [4, this.copyItems(c)] : [3, 4]);
              case 1:
                return (
                  (r = e.sent()),
                  [4, this.pasteItems(r, { parent: u, beforeItem: h })]
                );
              case 2:
                return (n = e.sent()), [4, this.mSession.deleteFile(r)];
              case 3:
                return e.sent(), [2, n];
              case 4:
                return (
                  (i = t.reorder ? c : this.sortItems(c)),
                  (a = i.map(function (e) {
                    return e.id;
                  })),
                  (s = this.getParentsToUpdateAfterRemove(c, !1, !0, !0, [u])),
                  null !=
                    (o =
                      u instanceof y.SetArticleItem ? u : u.getSetArticle()) &&
                    (S.utils.array.contains(s, o) || s.push(o)),
                  [4, this.removeItemsFromCurrentSet(c, null == o)]
                );
              case 5:
                return (
                  e.sent(),
                  [
                    4,
                    this.mSession.basket.relocateItems(
                      u.id,
                      null != h ? h.id : '',
                      a
                    ),
                  ]
                );
              case 6:
                return 'Done' !== (l = e.sent())
                  ? [3, 10]
                  : null == o
                  ? [3, 8]
                  : [4, this.addItemsToCurrentSet(c)];
              case 7:
                e.sent(), (e.label = 8);
              case 8:
                return [4, this.updateParentsAfterInsertOrRemove(s)];
              case 9:
                return e.sent(), [3, 11];
              case 10:
                if ('NothingToDo' !== l)
                  throw S.utils.newError('Failed to relocate items: ' + l);
                e.label = 11;
              case 11:
                return [2, S.utils.array.clone(c)];
            }
          });
        });
      }),
      (E.prototype.moveItems = function (c, u) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (0 === c.length) return [2, 'NothingToDo'];
                if (
                  ((t = this.sortItems(c)),
                  (r = t[0]),
                  (i = n = null) == (a = r.parent))
                )
                  throw S.utils.newError(
                    'Failed to move items: current parent not found'
                  );
                if ('Unindent' !== u && 'Indent' !== u) return [3, 2];
                if ('Unindent' === u) {
                  if (null == (n = a.parent)) return [2, 'NoGrandparent'];
                } else if (null == (n = a.getPrevChild(r))) return [2, 'NoPredecessor'];
                return (
                  (i = n instanceof y.SetArticleItem ? n : n.getSetArticle()),
                  [4, this.removeItemsFromCurrentSet(t, null == i)]
                );
              case 1:
                e.sent(), (e.label = 2);
              case 2:
                return (
                  (s = t.map(function (e) {
                    return e.id;
                  })),
                  [4, this.mSession.basket.moveItems(s, u)]
                );
              case 3:
                return 'Done' !== (o = e.sent())
                  ? [3, 9]
                  : null != n
                  ? [3, 5]
                  : [4, a.updateItem(1)];
              case 4:
                return e.sent(), [3, 9];
              case 5:
                return (
                  (l = [a, n]),
                  null == i
                    ? [3, 7]
                    : (n !== i && a !== i && l.push(i),
                      [4, this.addItemsToCurrentSet(t)])
                );
              case 6:
                e.sent(), (e.label = 7);
              case 7:
                return [4, this.updateParentsAfterInsertOrRemove(l)];
              case 8:
                e.sent(), (e.label = 9);
              case 9:
                return [2, o];
            }
          });
        });
      }),
      (E.prototype.getPossibleMoveDirections = function (e, t) {
        var r = new Set();
        if (0 === e.length) return r;
        var n = e[0].parent;
        if (null == n) return r;
        for (var i = 1; i < e.length; ++i) if (e[i].parent !== n) return r;
        for (
          var a = this.sortItems(e),
            s = a[0],
            o = a[a.length - 1],
            l = a[0].childIndex,
            i = 1;
          i < a.length;
          ++i
        ) {
          var c = a[i].childIndex;
          if (c - l != 1) return r;
          l = c;
        }
        var u = !1;
        if (
          (null != t && (u = t.isCalculationLocked(a)),
          0 < s.childIndex && r.add('Up'),
          o.childIndex < n.children.length - 1 && r.add('Down'),
          null != n.parent && o.childIndex === n.children.length - 1)
        ) {
          var h = !0;
          if (u)
            for (
              var m =
                  n.parent instanceof y.SetArticleItem
                    ? n.parent
                    : n.parent.getSetArticle(),
                d = 0,
                p = a;
              d < p.length;
              d++
            )
              if (m != p[d].getSetArticle()) {
                h = !1;
                break;
              }
          h && r.add('Unindent');
        }
        var g = n.getPrevChild(s);
        if (null != g && 'Text' !== g.type) {
          for (var f = !1, I = 0, _ = a; I < _.length; I++)
            if (_[I].isGroup) {
              f = !0;
              break;
            }
          var v = !f || g.isGroup;
          if (v && u)
            for (
              var m = g instanceof y.SetArticleItem ? g : g.getSetArticle(),
                b = 0,
                w = a;
              b < w.length;
              b++
            )
              if (m != w[b].getSetArticle()) {
                v = !1;
                break;
              }
          v && r.add('Indent');
        }
        return r;
      }),
      (E.prototype.setItemAlternativeState = function (g, f) {
        return __awaiter(this, void 0, void 0, function () {
          var a, s, t, r, n, i, o, l, c, u, h, m, d, p;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (0 === g.length) return [2];
                e.label = 1;
              case 1:
                for (
                  e.trys.push([1, , 7, 8]),
                    this._beginItemUpdate(),
                    a = function (e) {
                      for (var t = 0, r = e.children; t < r.length; t++) {
                        var n,
                          i = r[t];
                        i instanceof y.ArticleItem &&
                          ((n = i.getMainArticle()), s.add(n)),
                          a(i);
                      }
                    },
                    s = new Set(),
                    t = new Array(),
                    r = 0,
                    n = g;
                  r < n.length;
                  r++
                )
                  (i = n[r]) instanceof y.ArticleItem
                    ? ((o = i.getMainArticle()), s.add(o))
                    : i instanceof y.FolderItem && t.push(i);
                return 0 === t.length && 0 === s.size
                  ? [2]
                  : (((l = new S.eaiws.basket.ItemSelectionOptions()).wholeComposite = !0),
                    0 < s.size
                      ? ((c = Array.from(s)),
                        (u = c.map(function (e) {
                          return e.id;
                        })),
                        [
                          4,
                          this.mSession.basket.changeAlternativePositionState(
                            u,
                            '',
                            f,
                            l
                          ),
                        ])
                      : [3, 3]);
              case 2:
                e.sent(), (e.label = 3);
              case 3:
                return 0 < t.length
                  ? ((l.subItems = !0),
                    (u = t.map(function (e) {
                      return e.id;
                    })),
                    [
                      4,
                      this.mSession.basket.changeAlternativePositionState(
                        u,
                        '',
                        f,
                        l
                      ),
                    ])
                  : [3, 5];
              case 4:
                for (e.sent(), h = 0, m = t; h < m.length; h++)
                  (d = m[h]), a(d);
                e.label = 5;
              case 5:
                return (
                  (p = new Array()),
                  s.forEach(function (e) {
                    p.push(e.updateWholeComposite(2)),
                      e.invalidateGroupCalculations();
                  }),
                  [4, Promise.all(p)]
                );
              case 6:
                return e.sent(), [3, 8];
              case 7:
                return this._endItemUpdate(), [7];
              case 8:
                return [2];
            }
          });
        });
      }),
      (E.prototype.convertToUserArticles = function (f) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c, u, h, m, d, p, g;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (0 === f.length) return [2, []];
                e.label = 1;
              case 1:
                for (
                  e.trys.push([1, , 4, 5]),
                    this._beginItemUpdate(),
                    t = new Set(),
                    r = 0,
                    n = f;
                  r < n.length;
                  r++
                )
                  !((i = n[r]) instanceof y.ArticleItem) ||
                    i instanceof y.UserArticleItem ||
                    i instanceof y.SetArticleItem ||
                    ((a = i.getMainArticle()), t.add(a));
                return 0 === t.size
                  ? [2, []]
                  : ((s = Array.from(t)),
                    (o = s.map(function (e) {
                      return e.id;
                    })),
                    (l = this.getParentsToUpdateAfterRemove(s, !0, !1)),
                    ((c = new S.eaiws.basket.ItemSelectionOptions()).wholeComposite = !0),
                    [4, this.mSession.basket.convertToUserArticles(o, c)]);
              case 2:
                return (
                  (u = e.sent()),
                  [4, this.updateParentsAfterInsertOrRemove(l, u)]
                );
              case 3:
                for (e.sent(), h = new Array(), m = 0, d = u; m < d.length; m++)
                  (p = d[m]),
                    null != (g = this.getItemById(p)) &&
                      g instanceof y.UserArticleItem &&
                      h.push(g);
                return [2, h];
              case 4:
                return this._endItemUpdate(), [7];
              case 5:
                return [2];
            }
          });
        });
      }),
      (E.prototype.convertToSetArticle = function (a) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  e.trys.push([0, , 5, 6]),
                  this._beginItemUpdate(),
                  this._beginCaching(),
                  ((t = new S.eaiws.basket.OperationMode()).breakUpSetArticles = !0),
                  (r = null == a.parent ? this.mRoot : a.parent),
                  [4, this.mSession.basket.convertToSetArticle(a.id, t)]
                );
              case 1:
                if (((n = e.sent()), S.utils.string.isNullOrEmpty(n)))
                  throw new Error('Failed to convert to set article.');
                return [4, this._fetchEaiwsItems([n], !0, !1)];
              case 2:
                return (
                  e.sent(), [4, this.updateParentsAfterInsertOrRemove([r], [n])]
                );
              case 3:
                if ((e.sent(), null == (i = this.getItemById(n))))
                  throw new Error('Failed to convert to set article.');
                return [4, i.updateItem(-2147483647)];
              case 4:
                return e.sent(), [2, i];
              case 5:
                return this._endCaching(), this._endItemUpdate(), [7];
              case 6:
                return [2];
            }
          });
        });
      }),
      (E.prototype.breakUpSetArticle = function (i) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  e.trys.push([0, , 5, 6]),
                  this._beginItemUpdate(),
                  this._beginCaching(),
                  (t = null == i.parent ? this.mRoot : i.parent),
                  [4, this.mSession.basket.breakUpSetArticle(i.id)]
                );
              case 1:
                if (((r = e.sent()), S.utils.string.isNullOrEmpty(r)))
                  throw new Error('Failed to break up set article.');
                return [4, this._fetchEaiwsItems([r], !0, !1)];
              case 2:
                return (
                  e.sent(), [4, this.updateParentsAfterInsertOrRemove([t], [r])]
                );
              case 3:
                if ((e.sent(), null == (n = this.getItemById(r))))
                  throw new Error('Failed to break up set article.');
                return [4, n.updateItem(-2147483647)];
              case 4:
                return e.sent(), [2, n];
              case 5:
                return this._endCaching(), this._endItemUpdate(), [7];
              case 6:
                return [2];
            }
          });
        });
      }),
      (E.prototype.mergeArticles = function (g, f) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c, u, h, m, d, p;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                for (
                  t = { folderMode: 'Ignore' },
                    Object.assign(t, f),
                    r = new Set(),
                    n = new Set(),
                    i = 0,
                    a = g;
                  i < a.length;
                  i++
                )
                  ((p = a[i]).isOfmlArticle ||
                    p instanceof y.UserArticleItem) &&
                    n.add(p.getMainArticle().id),
                    p instanceof y.FolderItem && r.add(p.id);
                return 0 < r.size && 'Delete' === t.folderMode
                  ? (((s = new S.eaiws.basket.DeleteItemsOptions()).subItems = !1),
                    [4, this.mSession.basket.deleteItems(Array.from(r), s)])
                  : [3, 2];
              case 1:
                e.sent(), (e.label = 2);
              case 2:
                return (
                  ((o = new S.eaiws.basket.ItemSelectionOptions()).wholeComposite = !0),
                  (l = Array.from(n)),
                  'MergeChildren' === t.folderMode &&
                    ((o.subItems = !0), l.push.apply(l, Array.from(r))),
                  0 < l.length
                    ? [4, this.mSession.basket.mergeBasketArticles(l, o)]
                    : [3, 4]
                );
              case 3:
                return (c = e.sent()), [3, 5];
              case 4:
                (c = {}), (e.label = 5);
              case 5:
                if (
                  !(
                    'Delete' === t.folderMode ||
                    (null != c.addedItems && 0 < c.addedItems.length) ||
                    (null != c.removedItems && 0 < c.removedItems.length) ||
                    (null != c.movedItems && 0 < c.movedItems.length) ||
                    (null != c.updatedItems && 0 < c.updatedItems.length)
                  )
                )
                  return [3, 13];
                e.label = 6;
              case 6:
                return (
                  e.trys.push([6, , 11, 12]),
                  this._beginItemUpdate(),
                  this._beginCaching(),
                  [4, this._fetchEaiwsItems([this.mRoot.id], !0, !0)]
                );
              case 7:
                return e.sent(), [4, this.mRoot.updateItem(-2147483647)];
              case 8:
                if ((e.sent(), null == c.updatedItems)) return [3, 10];
                for (
                  u = new Array(), h = 0, m = c.updatedItems;
                  h < m.length;
                  h++
                )
                  (d = m[h]),
                    (p = this.getItemById(d)) instanceof y.ArticleItem &&
                      u.push(p.updateWholeComposite(10));
                return [4, Promise.all(u)];
              case 9:
                e.sent(), (e.label = 10);
              case 10:
                return [2, !0];
              case 11:
                return this._endCaching(), this._endItemUpdate(), [7];
              case 12:
                return [3, 14];
              case 13:
                return [2, !1];
              case 14:
                return [2];
            }
          });
        });
      }),
      (E.prototype.updateOfmlArticles = function (A, P, k) {
        return __awaiter(this, void 0, void 0, function () {
          var t,
            r,
            n,
            i,
            a,
            s,
            o,
            l,
            c,
            u,
            h,
            m,
            d,
            p,
            g,
            f,
            I,
            _,
            v,
            b,
            w,
            y,
            C = this;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                for (t = new Set(), r = 0, n = A; r < n.length; r++)
                  (i = n[r]).isOfmlArticle && t.add(i.getMainArticle());
                return (
                  (a = new Array()),
                  (s = new Array()),
                  (o = new Array()),
                  t.forEach(function (e) {
                    switch (e.ofmlUpdateState) {
                      case 'Unknown':
                      case 'Updatable':
                        o.push(e);
                        break;
                      case 'Migratable':
                        P ? o.push(e) : s.push(e);
                        break;
                      case 'UpToDate':
                        break;
                      default:
                        a.push(e);
                    }
                  }),
                  (l = { updated: 0, migratable: s.length, invalid: a.length }),
                  0 === o.length
                    ? [2, l]
                    : (((c = new S.eaiws.basket.UpdateBasketArticlesOptions()).migrate = P),
                      (c.update = !0),
                      (u = o.map(function (e) {
                        return e.id;
                      })),
                      (h = new Array()),
                      (m = 0),
                      (p = d = !1),
                      null != k && (d = !k(m, o.length)),
                      [
                        4,
                        S.utils.async.forEachParallel(
                          o,
                          function (e, n) {
                            return __awaiter(C, void 0, void 0, function () {
                              var t, r;
                              return __generator(this, function (e) {
                                switch (e.label) {
                                  case 0:
                                    if (d || p) return [2];
                                    e.label = 1;
                                  case 1:
                                    return (
                                      e.trys.push([1, 3, , 4]),
                                      [
                                        4,
                                        this.mSession.basket.updateBasketArticles(
                                          [n.id],
                                          null,
                                          c
                                        ),
                                      ]
                                    );
                                  case 2:
                                    return (
                                      (t = e.sent()), h.push.apply(h, t), [3, 4]
                                    );
                                  case 3:
                                    throw ((r = e.sent()), (p = !0), r);
                                  case 4:
                                    return (
                                      m++,
                                      null != k && (d = d || !k(m, o.length)),
                                      [2]
                                    );
                                }
                              });
                            });
                          },
                          E.MAX_CONCURRENT_ARTICLE_UPDATES
                        ),
                      ])
                );
              case 1:
                e.sent(),
                  this._beginItemUpdate(),
                  this._beginCaching(),
                  (e.label = 2);
              case 2:
                for (
                  e.trys.push([2, , 8, 9]), g = new Map(), f = 0, I = h;
                  f < I.length;
                  f++
                )
                  (_ = I[f]), g.set(_.itemId, _.updateState);
                this._fetchEaiwsItems(u, !1, !0),
                  (v = 0),
                  (b = o),
                  (e.label = 3);
              case 3:
                return v < b.length
                  ? ((w = b[v]),
                    null != (y = g.get(w.id)) && w._setOfmlUpdateState(y, !1),
                    'UpToDate' !== y
                      ? [3, 5]
                      : (l.updated++, [4, w.updateWholeComposite(-65)]))
                  : [3, 7];
              case 4:
                return (
                  e.sent(), this.eventOfmlArticleUpdated.trigger(w), [3, 6]
                );
              case 5:
                'Migratable' === y ? l.migratable++ : l.invalid++,
                  (e.label = 6);
              case 6:
                return v++, [3, 3];
              case 7:
                return [3, 9];
              case 8:
                return this._endCaching(), this._endItemUpdate(), [7];
              case 9:
                return [2, l];
            }
          });
        });
      }),
      (E.prototype.fetchOfmlUpdateStates = function (g) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c, u, h, m, d, p;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this._fetchItemPropertiesLock.waitWhileLocked()];
              case 1:
                for (e.sent(), t = new Set(), r = 0, n = g; r < n.length; r++)
                  (p = n[r]).isOfmlArticle &&
                    'Unknown' === (i = p.getMainArticle()).ofmlUpdateState &&
                    t.add(i.id);
                if (0 === t.size) return [2];
                e.label = 2;
              case 2:
                e.trys.push([2, , 7, 8]),
                  this._beginItemUpdate(),
                  ((a = new S.eaiws.basket.UpdateBasketArticlesOptions()).migrate = !1),
                  (a.update = !1),
                  (s = S.utils.array.chunk(
                    Array.from(t),
                    E.FETCH_UPDATE_STATE_CHUNK_SIZE
                  )),
                  (o = new Array()),
                  (l = 0),
                  (c = s),
                  (e.label = 3);
              case 3:
                return l < c.length
                  ? ((u = c[l]),
                    [4, this.session.basket.updateBasketArticles(u, null, a)])
                  : [3, 6];
              case 4:
                (d = e.sent()), o.push.apply(o, d), (e.label = 5);
              case 5:
                return l++, [3, 3];
              case 6:
                for (h = 0, m = o; h < m.length; h++)
                  (d = m[h]),
                    null != (p = this.getItemById(d.itemId)) &&
                      p instanceof y.ArticleItem &&
                      p._setOfmlUpdateState(d.updateState, !1);
                return [3, 8];
              case 7:
                return this._endItemUpdate(), [7];
              case 8:
                return [2];
            }
          });
        });
      }),
      (E.prototype.importObx = function (i, a) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  (t = i instanceof ArrayBuffer ? new Blob([i]) : i),
                  [4, this.mSession.uploadFile('CutBuffer', t, a)]
                );
              case 1:
                return (
                  (r = e.sent()),
                  S.utils.string.isNullOrEmpty(r)
                    ? [2, null]
                    : [4, this.pasteItems(r)]
                );
              case 2:
                return (n = e.sent()), [4, this.mSession.deleteFile(r)];
              case 3:
                return e.sent(), [2, n];
            }
          });
        });
      }),
      (E.prototype.importPec = function (i, a) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, (t = new JSZip()).loadAsync(i)];
              case 1:
                return (
                  e.sent(),
                  null == (r = t.file('document.obx'))
                    ? [2, new Array()]
                    : [4, r.async('arraybuffer')]
                );
              case 2:
                return (n = e.sent()), [2, this.importObx(n, a)];
            }
          });
        });
      }),
      (E.prototype.cloneItem = function (n) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (n === this.mRoot)
                  throw new Error("Root item can't be cloned.");
                return [
                  4,
                  this.copyItems([n], { wholeComposite: !0, children: !1 }),
                ];
              case 1:
                return (
                  (t = e.sent()), [4, this.pasteItems(t, { parent: n.parent })]
                );
              case 2:
                return (r = e.sent()), [4, this.mSession.deleteFile(t)];
              case 3:
                if ((e.sent(), 0 < r.length)) return [2, r[0]];
                throw new Error('Failed to clone item.');
            }
          });
        });
      }),
      (E.prototype.invalidateHeaderCalculation = function () {
        n.prototype.invalidateHeaderCalculation.call(this);
        for (var e = 0, t = this.mViews; e < t.length; e++)
          t[e].invalidateHeaderCalculation();
      }),
      (E.prototype.checkConsistency = function () {
        return __awaiter(this, void 0, void 0, function () {
          var a,
            r = this;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  (a = function (e) {
                    var t = e.getCachedItemProperties();
                    if (
                      null != t &&
                      null != t.article &&
                      !0 === t.article.inconsistencyFlag
                    )
                      return !1;
                    for (var r = 0, n = e.children; r < n.length; r++) {
                      var i = n[r];
                      if (!a(i)) return !1;
                    }
                    return !0;
                  }),
                  [
                    4,
                    this.mRoot.fetchItemProperties(!0, function (e) {
                      if (e === r.mRoot) return !1;
                      var t = e.type;
                      return (
                        'Folder' !== t &&
                        'Text' !== t &&
                        'UserArticle' !== t &&
                        'SetArticle' !== t &&
                        'Undefined' !== t
                      );
                    }),
                  ]
                );
              case 1:
                return e.sent(), [2, a(this.mRoot)];
            }
          });
        });
      }),
      (E.InitSessionGeneratedImageOptions = function (t) {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [
                  4,
                  t.basket.getGeneratedImage(
                    '',
                    E.DEFAULT_GENERATED_IMAGE_OPTIONS
                  ),
                ];
              case 1:
                return e.sent(), [2];
            }
          });
        });
      }),
      (E.prototype._updateViewItems = function (n, i) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                (t = 0), (r = this.mViews), (e.label = 1);
              case 1:
                return t < r.length ? [4, r[t]._updateViewItem(n, i)] : [3, 4];
              case 2:
                e.sent(), (e.label = 3);
              case 3:
                return t++, [3, 1];
              case 4:
                return [2];
            }
          });
        });
      }),
      (E.prototype._getPricingProcedure = function () {
        return this.mCalcManager.pricingProcedure;
      }),
      (E.prototype._getGeneratedImageOptions = function () {
        return this.mGeneratedImageOptions;
      }),
      (E.prototype.createItem = function (e, t, r) {
        var n;
        switch (r.itemType) {
          case 'Folder':
            n = new y.FolderItem(this, e, t, r);
            break;
          case 'PartialPlanning':
          case 'Aggregate':
          case 'Article':
            n = new y.ArticleItem(this, e, t, r);
            break;
          case 'UserArticle':
            n = new y.UserArticleItem(this, e, t, r);
            break;
          case 'SetArticle':
            n = new y.SetArticleItem(this, e, t, r);
            break;
          case 'Text':
            n = new y.TextItem(this, e, t, r);
            break;
          default:
            n = new y.BasketItem(this, e, t, r);
        }
        return n;
      }),
      (E.prototype.prepareBasketColumns = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mSession.basket.getBasketColumns()];
              case 1:
                for (
                  t = e.sent(), n = r = !1, i = 0, a = t;
                  i < a.length &&
                  ((s = a[i]),
                  r || s.id !== E.BASKET_COLUMN_ID_USER_IMAGE || (r = !0),
                  n || s.id !== E.BASKET_COLUMN_ID_EXT_ITEM_NUMBER || (n = !0),
                  !r || !n);
                  i++
                );
                return r && n
                  ? [3, 3]
                  : ((o = new Array()),
                    r ||
                      (((l = new S.eaiws.basket.BasketColumn()).id =
                        E.BASKET_COLUMN_ID_USER_IMAGE),
                      (l.type = 'Image'),
                      (l.name = 'User Image'),
                      (l.title = 'User Image'),
                      (l.defaultColumn =
                        '73bd68f4-da62-11d8-b9d6-00e081513ada'),
                      (l.removable = !1),
                      o.push(l)),
                    n ||
                      (((l = new S.eaiws.basket.BasketColumn()).id =
                        E.BASKET_COLUMN_ID_EXT_ITEM_NUMBER),
                      (l.type = 'Text'),
                      (l.name = 'External Item Number'),
                      (l.title = 'Ext. Item No.'),
                      (l.removable = !1),
                      o.push(l)),
                    [4, this.mSession.basket.addBasketColumns(o)]);
              case 2:
                e.sent(), (e.label = 3);
              case 3:
                return [2];
            }
          });
        });
      }),
      (E.prototype.setGeneratedImageResolution = function (e) {
        if (e !== this.mGeneratedImageResolution) {
          this.mGeneratedImageResolution = Math.round(e);
          for (
            var t = 'width=' + this.mGeneratedImageResolution, r = 0;
            r < this.mGeneratedImageOptions.length;
            ++r
          )
            if (this.mGeneratedImageOptions[r].startsWith('width='))
              return void (this.mGeneratedImageOptions[r] = t);
          this.mGeneratedImageOptions.push(t);
        }
      }),
      (E.prototype.getParentsToUpdateAfterRemove = function (e, t, h, r, n) {
        void 0 === r && (r = !1);
        for (
          var i,
            m = function (e, t, r) {
              if (null != e.parent) {
                var n = null == r ? (t.add(e.parent), e) : r;
                if (e instanceof y.ArticleItem)
                  for (var i = 0, a = e.getSubArticles(!1); i < a.length; i++) {
                    var s = a[i].parent;
                    null != s &&
                      s !== n &&
                      (s.isChildOf(n, !1) || s === n.parent || t.add(s));
                  }
                var o = e.getSetArticle();
                if ((null != o && t.add(o), h))
                  for (var l = 0, c = e.children; l < c.length; l++) {
                    var u = c[l];
                    m(u, t, n);
                  }
              }
            },
            a = new Array(),
            s = 0,
            o = e;
          s < o.length;
          s++
        )
          (d = o[s]) instanceof y.ArticleItem
            ? ((i = d.getMainArticle()),
              t ? a.push(i) : (i !== d && !r) || a.push(d))
            : a.push(d);
        for (var l = new Set(), c = 0, u = a; c < u.length; c++) {
          var d = u[c];
          m(d, l);
        }
        if (null != n)
          for (var p = 0, g = n; p < g.length; p++) {
            var f = g[p];
            l.add(f);
          }
        var I = new Array();
        return (
          l.forEach(function (e) {
            !(function (e) {
              for (var t = 0, r = a; t < r.length; t++) {
                var n = r[t];
                if (n === e) return 1;
                if (h && e.isChildOf(n, !1)) return 1;
              }
            })(e) && I.push(e);
          }),
          I
        );
      }),
      (E.prototype.updateParentsAfterInsertOrRemove = function (s, o) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  e.trys.push([0, , 3, 4]),
                  this.beginSelectionChange(),
                  this._beginItemUpdate(),
                  this._beginCaching(),
                  (t = new Array()),
                  (r = s.map(function (e) {
                    return e.id;
                  })),
                  null != o && r.push.apply(r, o),
                  [4, this._fetchEaiwsItems(r, !1, !1)]
                );
              case 1:
                for (e.sent(), n = 0, i = s; n < i.length; n++)
                  (a = i[n]) instanceof y.SetArticleItem
                    ? t.push(a.updateItem(3))
                    : t.push(a.updateItem(1)),
                    a.invalidateGroupCalculations();
                return [4, Promise.all(t)];
              case 2:
                return e.sent(), [3, 4];
              case 3:
                return (
                  this._endCaching(),
                  this._endItemUpdate(),
                  this.endSelectionChange(),
                  [7]
                );
              case 4:
                return [2];
            }
          });
        });
      }),
      (E.prototype.sortItems = function (e) {
        if (e.length < 2) return S.utils.array.clone(e);
        var t = this.mSelection.map(function (e) {
          return { item: e, no: e._getItemNumberAsArray() };
        });
        return (
          t.sort(function (e, t) {
            for (
              var r, n, i = 0;
              i < e.no.length && (r = e.no[i]) === (n = t.no[i]);
              ++i
            );
            return r === n
              ? e.no.length < t.no.length
                ? -1
                : 0
              : void 0 === r || void 0 === n
              ? e.no.length - t.no.length
              : r - n;
          }),
          t.map(function (e) {
            return e.item;
          })
        );
      }),
      (E.prototype.getInsertPosition = function (e, t, r) {
        if (null != e)
          return { parent: e, beforeItemId: null != t ? t.id : null };
        if (this.mSelection.length < 1)
          return { parent: this.mRoot, beforeItemId: null };
        var n,
          i,
          a = null;
        if (
          null !=
            (a =
              (i =
                1 === this.mSelection.length
                  ? this.mSelection[0]
                  : (n = this.sortItems(this.mSelection))[n.length - 1])
                .isGroup && 1 === this.mSelection.length
                ? i
                : i.getParentGroup()) &&
          r
        )
          for (; null != a && a instanceof y.SetArticleItem; )
            a = a.getParentGroup();
        null == a && (a = this.mRoot);
        var s = a.getNextChild(i);
        return { parent: a, beforeItemId: null != s ? s.id : null };
      }),
      (E.prototype.addItemsToCurrentSet = function (u) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (0 === u.length) return [2];
                e.label = 1;
              case 1:
                return (
                  e.trys.push([1, 5, 6, 7]),
                  this._beginItemUpdate(),
                  this._beginCaching(),
                  ((t = new S.eaiws.basket.OperationMode()).subPositions = !0),
                  (t.breakUpSetArticles = !0),
                  [
                    4,
                    this.mSession.basket.addToSetArticle(
                      u.map(function (e) {
                        return e.id;
                      }),
                      t
                    ),
                  ]
                );
              case 2:
                for (e.sent(), r = new Array(), n = 0, i = u; n < i.length; n++)
                  (l = i[n]) instanceof y.SetArticleItem || r.push(l);
                return [
                  4,
                  this._fetchEaiwsItems(
                    r.map(function (e) {
                      return e.id;
                    }),
                    !0,
                    !1
                  ),
                ];
              case 3:
                for (e.sent(), a = new Array(), s = 0, o = r; s < o.length; s++)
                  (l = o[s]), a.push(l.updateItem(-2147483647));
                return [4, Promise.all(a)];
              case 4:
                return e.sent(), [3, 7];
              case 5:
                return (
                  (c = e.sent()),
                  S.utils.Log.error('Failed to add items to set.', c),
                  [3, 7]
                );
              case 6:
                return this._endCaching(), this._endItemUpdate(), [7];
              case 7:
                return [2];
            }
          });
        });
      }),
      (E.prototype.removeItemsFromCurrentSet = function (m, d) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c, u, h;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (0 === m.length) return [2];
                for (t = new Set(), r = 0, n = m; r < n.length; r++)
                  null != (i = n[r]).getSetArticle() && t.add(i);
                if (0 === t.size) return [2];
                e.label = 1;
              case 1:
                return (
                  e.trys.push([1, 6, 7, 8]),
                  this._beginItemUpdate(),
                  this._beginCaching(),
                  (a = Array.from(t)),
                  (s = a.map(function (e) {
                    return e.id;
                  })),
                  (new S.eaiws.basket.OperationMode().subPositions = !0),
                  [4, this.mSession.basket.removeFromSetArticle(s)]
                );
              case 2:
                return (
                  e.sent(), d ? [4, this._fetchEaiwsItems(s, !0, !1)] : [3, 5]
                );
              case 3:
                for (e.sent(), o = new Array(), l = 0, c = a; l < c.length; l++)
                  (u = c[l]), o.push(u.updateItem(-2147483647));
                return [4, Promise.all(o)];
              case 4:
                e.sent(), (e.label = 5);
              case 5:
                return [3, 8];
              case 6:
                return (
                  (h = e.sent()),
                  S.utils.Log.error('Failed to remove items from set.', h),
                  [3, 8]
                );
              case 7:
                return this._endCaching(), this._endItemUpdate(), [7];
              case 8:
                return [2];
            }
          });
        });
      }),
      (E.BASKET_COLUMN_ID_USER_IMAGE = 'cc080d73-88f4-4bfc-8ec1-e7e2ad30739a'),
      (E.BASKET_COLUMN_ID_EXT_ITEM_NUMBER =
        'c962203c-7e83-4a2f-8060-acaa4a06c921'),
      (E.MAX_CONCURRENT_ARTICLE_UPDATES = 5),
      (E.FETCH_UPDATE_STATE_CHUNK_SIZE = 250),
      (E.DEFAULT_GENERATED_IMAGE_OPTIONS = [
        'format=JPG',
        'shadowPlane=true',
        'shadowPlane.filter=DOF',
        'shadowPlane.color=0.4 0.4 0.4',
        'ambient=0.8 0.8 0.8',
        'renderMode=PBR',
      ]),
      (t = E),
      (y.Basket = t);
  })((egr = egr || {})),
  (function (e) {
    var o, i, t;
    function r(e) {
      (this.eventTaxSchemeChanged = new o.utils.ListenableEvent(this)),
        (this.eventCurrencyChanged = new o.utils.ListenableEvent(this)),
        (this.mBasket = e),
        (this.mPricingProcedure = null),
        (this.mTaxSchemeId = null),
        (this.mTaxScheme = null),
        (this.mDefaultTaxScheme = null),
        (this.mCurrency = ''),
        (this.mReferenceCurrency = null),
        (this.mExchangeRates = null);
    }
    (o = e.wcf || (e.wcf = {})),
      (i = o.bsk || (o.bsk = {})),
      Object.defineProperty(r.prototype, 'pricingProcedure', {
        get: function () {
          return this.mPricingProcedure;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'currency', {
        get: function () {
          return this.mCurrency;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (r.prototype.activatePricingProcedure = function (n) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return null != this.mPricingProcedure &&
                  this.mPricingProcedure.name === n
                  ? [2]
                  : ((t = this.mBasket.session),
                    (this.mPricingProcedure = null),
                    [4, this.isPriceProcActive(n)]);
              case 1:
                return e.sent() ? [3, 3] : [4, t.basket.addPriceCalculation(n)];
              case 2:
                e.sent(), (e.label = 3);
              case 3:
                return (
                  (r = this),
                  [4, o.eaiws.basket.PricingProcedureInfo.CreateInfo(t, n)]
                );
              case 4:
                return (
                  (r.mPricingProcedure = e.sent()),
                  this.mBasket.invalidateHeaderCalculation(),
                  [2]
                );
            }
          });
        });
      }),
      (r.prototype.setCurrency = function (t) {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return this.mCurrency == t
                  ? [2]
                  : [4, this.mBasket.session.basket.setCurrency(t)];
              case 1:
                return (
                  e.sent(),
                  (this.mCurrency = t),
                  this.resetUpToDateOfmlUpdateState(this.mBasket.root),
                  [
                    4,
                    this.mBasket._updateViewItems(
                      this.mBasket.root,
                      -2147483647
                    ),
                  ]
                );
              case 2:
                return (
                  e.sent(),
                  this.eventCurrencyChanged.trigger(),
                  [2, this.notifyCalculationChange(null)]
                );
            }
          });
        });
      }),
      (r.prototype.getTaxSchemeId = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return null != this.mTaxSchemeId
                  ? [2, this.mTaxSchemeId]
                  : [
                      4,
                      (t = this).mBasket.session.basket.getCurrentTaxScheme(),
                    ];
              case 1:
                return (t.mTaxSchemeId = e.sent()), [2, this.mTaxSchemeId];
            }
          });
        });
      }),
      (r.prototype.setTaxSchemeId = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return this.mTaxSchemeId === r
                  ? [2]
                  : [4, this.mBasket.session.basket.selectCurrentTaxScheme(r)];
              case 1:
                return (
                  e.sent(),
                  (this.mTaxSchemeId = r),
                  (this.mTaxScheme = null),
                  (this.mDefaultTaxScheme = null),
                  [4, this.getTaxScheme()]
                );
              case 2:
                return (
                  (t = e.sent()),
                  o.utils.string.isNotNullOrEmpty(t.currency) &&
                    t.currency !== this.mCurrency &&
                    ((this.mCurrency = t.currency),
                    this.eventCurrencyChanged.trigger()),
                  this.eventTaxSchemeChanged.trigger(),
                  [2, this.notifyCalculationChange(null, !0, !0)]
                );
            }
          });
        });
      }),
      (r.prototype.getTaxScheme = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return null != this.mTaxScheme
                  ? [2, this.mTaxScheme]
                  : [4, this.getTaxSchemeId()];
              case 1:
                return (
                  (t = e.sent()),
                  [4, (r = this).mBasket.session.basket.getTaxScheme(!0, t)]
                );
              case 2:
                return (r.mTaxScheme = e.sent()), [2, this.mTaxScheme];
            }
          });
        });
      }),
      (r.prototype.getDefaultTaxScheme = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return null != this.mDefaultTaxScheme
                  ? [2, this.mDefaultTaxScheme]
                  : [4, this.getTaxSchemeId()];
              case 1:
                return (
                  (t = e.sent()),
                  [4, (r = this).mBasket.session.basket.getTaxScheme(!1, t)]
                );
              case 2:
                return (
                  (r.mDefaultTaxScheme = e.sent()), [2, this.mDefaultTaxScheme]
                );
            }
          });
        });
      }),
      (r.prototype.setTaxRate = function (r, n, i) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.getTaxSchemeId()];
              case 1:
                return (
                  (t = e.sent()),
                  [4, this.mBasket.session.basket.setTaxRate(t, r, n, i)]
                );
              case 2:
                return (
                  e.sent(),
                  this._notifyTaxSchemeChanged(),
                  [2, this.notifyCalculationChange(null)]
                );
            }
          });
        });
      }),
      (r.prototype.resetTaxRate = function (r, n) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.getTaxSchemeId()];
              case 1:
                return (
                  (t = e.sent()),
                  [4, this.mBasket.session.basket.resetTaxRate(t, r, n)]
                );
              case 2:
                return (
                  e.sent(),
                  this._notifyTaxSchemeChanged(),
                  [2, this.notifyCalculationChange(null)]
                );
            }
          });
        });
      }),
      (r.prototype.resetTaxScheme = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.getTaxSchemeId()];
              case 1:
                return (
                  (t = e.sent()),
                  [4, this.mBasket.session.basket.resetTaxScheme(t)]
                );
              case 2:
                return (
                  e.sent(),
                  this._notifyTaxSchemeChanged(),
                  [2, this.notifyCalculationChange(null)]
                );
            }
          });
        });
      }),
      (r.prototype.getExchangeRates = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return null != this.mExchangeRates
                  ? [2, this.mExchangeRates]
                  : [4, (t = this).mBasket.session.basket.getExchangeRates()];
              case 1:
                return (
                  (t.mExchangeRates = e.sent()),
                  this.mExchangeRates.sort(function (e, t) {
                    return o.utils.string.compare(e.currency, t.currency);
                  }),
                  [2, this.mExchangeRates]
                );
            }
          });
        });
      }),
      (r.prototype.setExchangeRates = function (t) {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return 0 === t.length
                  ? [2]
                  : [4, this.mBasket.session.basket.setExchangeRates(t)];
              case 1:
                return (
                  e.sent(),
                  (this.mExchangeRates = null),
                  [2, this.notifyCalculationChange(null)]
                );
            }
          });
        });
      }),
      (r.prototype.getReferenceCurrency = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return null != this.mReferenceCurrency
                  ? [2, this.mReferenceCurrency]
                  : [
                      4,
                      (t = this).mBasket.session.basket.getReferenceCurrency(),
                    ];
              case 1:
                return (
                  (t.mReferenceCurrency = e.sent()),
                  [2, this.mReferenceCurrency]
                );
            }
          });
        });
      }),
      (r.prototype.setConditionDescription = function (t, r, n) {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == this.mPricingProcedure)
                  throw o.utils.newError(
                    o.utils.ERR_INVALID_STATE,
                    'no active pricing procedure'
                  );
                return [
                  4,
                  this.mBasket.session.basket.setConditionDescription(
                    this.mPricingProcedure.name,
                    t,
                    r,
                    n
                  ),
                ];
              case 1:
                return e.sent(), [2, this.notifyCalculationChange(null)];
            }
          });
        });
      }),
      (r.prototype.setConditionAmount = function (r, n, i, a, s) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == this.mPricingProcedure)
                  throw o.utils.newError(
                    o.utils.ERR_INVALID_STATE,
                    'no active pricing procedure'
                  );
                return 0 <
                  (t =
                    null != r
                      ? r.map(function (e) {
                          return e.id;
                        })
                      : ['']).length
                  ? [
                      4,
                      this.mBasket.session.basket.setConditionAmount(
                        t,
                        this.mPricingProcedure.name,
                        n,
                        i,
                        a,
                        s
                      ),
                    ]
                  : [3, 2];
              case 1:
                return e.sent(), [2, this.notifyCalculationChange(r)];
              case 2:
                return [2];
            }
          });
        });
      }),
      (r.prototype.setQuantityRelation = function (r, n, i, a, s) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == this.mPricingProcedure)
                  throw o.utils.newError(
                    o.utils.ERR_INVALID_STATE,
                    'no active pricing procedure'
                  );
                return 0 <
                  (t =
                    null != r
                      ? r.map(function (e) {
                          return e.id;
                        })
                      : ['']).length
                  ? [
                      4,
                      this.mBasket.session.basket.setQuantityRelation(
                        t,
                        this.mPricingProcedure.name,
                        n,
                        i,
                        a,
                        s
                      ),
                    ]
                  : [3, 2];
              case 1:
                return e.sent(), [2, this.notifyCalculationChange(r)];
              case 2:
                return [2];
            }
          });
        });
      }),
      (r.prototype.resetConditionAmount = function (r, n, i) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == this.mPricingProcedure)
                  throw o.utils.newError(
                    o.utils.ERR_INVALID_STATE,
                    'no active pricing procedure'
                  );
                return 0 <
                  (t =
                    null != r
                      ? r.map(function (e) {
                          return e.id;
                        })
                      : ['']).length
                  ? [
                      4,
                      this.mBasket.session.basket.resetConditionAmount(
                        t,
                        this.mPricingProcedure.name,
                        n,
                        i
                      ),
                    ]
                  : [3, 2];
              case 1:
                return e.sent(), [2, this.notifyCalculationChange(r)];
              case 2:
                return [2];
            }
          });
        });
      }),
      (r.prototype.resetQuantityRelation = function (r, n, i) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == this.mPricingProcedure)
                  throw o.utils.newError(
                    o.utils.ERR_INVALID_STATE,
                    'no active pricing procedure'
                  );
                return 0 <
                  (t =
                    null != r
                      ? r.map(function (e) {
                          return e.id;
                        })
                      : ['']).length
                  ? [
                      4,
                      this.mBasket.session.basket.resetQuantityRelation(
                        t,
                        this.mPricingProcedure.name,
                        n,
                        i
                      ),
                    ]
                  : [3, 2];
              case 1:
                return e.sent(), [2, this.notifyCalculationChange(r)];
              case 2:
                return [2];
            }
          });
        });
      }),
      (r.prototype.addManualCondition = function (r, n) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == this.mPricingProcedure)
                  throw o.utils.newError(
                    o.utils.ERR_INVALID_STATE,
                    'no active pricing procedure'
                  );
                return 0 <
                  (t =
                    null != r
                      ? r.map(function (e) {
                          return e.id;
                        })
                      : ['']).length
                  ? [
                      4,
                      this.mBasket.session.basket.addManualCondition(
                        t,
                        this.mPricingProcedure.name,
                        n
                      ),
                    ]
                  : [3, 2];
              case 1:
                return e.sent(), [2, this.notifyCalculationChange(r)];
              case 2:
                return [2];
            }
          });
        });
      }),
      (r.prototype.removeCondition = function (r, n, i) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == this.mPricingProcedure)
                  throw o.utils.newError(
                    o.utils.ERR_INVALID_STATE,
                    'no active pricing procedure'
                  );
                return 0 <
                  (t =
                    null != r
                      ? r.map(function (e) {
                          return e.id;
                        })
                      : ['']).length
                  ? [
                      4,
                      this.mBasket.session.basket.removeCondition(
                        t,
                        this.mPricingProcedure.name,
                        n,
                        i
                      ),
                    ]
                  : [3, 2];
              case 1:
                return e.sent(), [2, this.notifyCalculationChange(r)];
              case 2:
                return [2];
            }
          });
        });
      }),
      (r.prototype.getGroupCalculation = function (e) {
        var t = this;
        if (null == this.mPricingProcedure)
          throw o.utils.newError(
            o.utils.ERR_INVALID_STATE,
            'no active pricing procedure'
          );
        if (e.length < 2)
          throw o.utils.newError(
            o.utils.ERR_INVALID_ARGUMENT,
            '2 or more items required'
          );
        return this.mBasket.session.basket
          .getPriceCalculationSheet(
            e.map(function (e) {
              return e.id;
            }),
            this.mPricingProcedure.name
          )
          .then(function (e) {
            return new o.eaiws.basket.CalculationSheetInfo(
              t.mPricingProcedure,
              e
            );
          });
      }),
      (r.prototype._clear = function () {
        (this.mPricingProcedure = null),
          (this.mTaxSchemeId = null),
          (this.mTaxScheme = null),
          (this.mDefaultTaxScheme = null),
          (this.mCurrency = ''),
          (this.mReferenceCurrency = null),
          (this.mExchangeRates = null);
      }),
      (r.prototype._loadFromSession = function () {
        var t = this;
        return this.mBasket.session.basket.getCurrency().then(function (e) {
          t.mCurrency = e;
        });
      }),
      (r.prototype._notifyTaxSchemeChanged = function () {
        (this.mTaxScheme = null), this.eventTaxSchemeChanged.trigger();
      }),
      (r.prototype.isPriceProcActive = function (n) {
        return this.mBasket.session.basket
          .listPricingProcedures(!0)
          .then(function (e) {
            for (var t = 0, r = e; t < r.length; t++)
              if (r[t].name === n) return !0;
            return !1;
          });
      }),
      (r.prototype.notifyCalculationChange = function (s, o, l) {
        return (
          void 0 === o && (o = !1),
          void 0 === l && (l = !1),
          __awaiter(this, void 0, void 0, function () {
            var t, r, n, i, a;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  (t = 8), o && (t |= 2), l && (t |= 16), (e.label = 1);
                case 1:
                  return (
                    e.trys.push([1, , 6, 7]),
                    this.mBasket._beginItemUpdate(),
                    null != s
                      ? [3, 3]
                      : [4, this.mBasket.root.updateItem(2147483648 | t)]
                  );
                case 2:
                  return (
                    e.sent(), this.mBasket.invalidateHeaderCalculation(), [3, 5]
                  );
                case 3:
                  for (r = new Array(), n = 0, i = s; n < i.length; n++)
                    (a = i[n]).isGroup && (t |= 2147483648),
                      r.push(a.updateItem(t));
                  return [4, Promise.all(r)];
                case 4:
                  e.sent(), (e.label = 5);
                case 5:
                  return [3, 7];
                case 6:
                  return this.mBasket._endItemUpdate(), [7];
                case 7:
                  return [2];
              }
            });
          })
        );
      }),
      (r.prototype.resetUpToDateOfmlUpdateState = function (e) {
        for (var t = 0, r = e.children; t < r.length; t++) {
          var n = r[t];
          n instanceof i.ArticleItem &&
            'UpToDate' === n.ofmlUpdateState &&
            n._setOfmlUpdateState('Updatable', !0),
            this.resetUpToDateOfmlUpdateState(n);
        }
      }),
      (t = r),
      (i.CalculationManager = t);
  })((egr = egr || {})),
  (function (e) {
    var r, t, n, i;
    function a() {
      return (null !== n && n.apply(this, arguments)) || this;
    }
    (r = e.wcf || (e.wcf = {})),
      (t = r.bsk || (r.bsk = {})),
      (n = t.BasketItem),
      __extends(a, n),
      Object.defineProperty(a.prototype, 'isGroup', {
        get: function () {
          return !0;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (a.prototype.setLabel = function (e) {
        var t = new r.eaiws.basket.ItemProperties();
        return (
          (t.folder = new r.eaiws.basket.FolderProperties()),
          (t.folder.name = e.trim()),
          this.setItemProperties(t, !0, !1)
        );
      }),
      (a.prototype.setShowSubTotal = function (e) {
        var t = new r.eaiws.basket.ItemProperties();
        return (
          (t.folder = new r.eaiws.basket.FolderProperties()),
          (t.folder.showSubTotal = e),
          this.setItemProperties(t, !1, !1)
        );
      }),
      (i = a),
      (t.FolderItem = i);
  })((egr = egr || {})),
  (function (e) {
    var n;
    (function (o) {
      var e;
      ((e = o.ItemLockFlags || (o.ItemLockFlags = {}))[(e.None = 0)] = 'None'),
        (e[(e.Delete = 1)] = 'Delete'),
        (e[(e.Configuration = 2)] = 'Configuration'),
        (e[(e.Calculation = 4)] = 'Calculation'),
        (e[(e.ItemProperties = 8)] = 'ItemProperties'),
        (e[(e.Image = 16)] = 'Image'),
        (e[(e.All = 4294967295)] = 'All');
      var t =
        (Object.defineProperty(r.prototype, 'lockedItems', {
          get: function () {
            return this.mLockedItems;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (r.prototype.dispose = function () {
          this.mBasket.eventItemDisposed.removeListener(this.onItemDisposed);
        }),
        (r.prototype.setLockedItems = function (e) {
          var s = this;
          (this.mLockedItems = new Map()),
            e.forEach(function (e, t) {
              var r,
                n,
                i,
                a = s.mBasket.getItemById(t);
              null != a &&
                (a instanceof o.ArticleItem
                  ? ((n = a.getMainArticle()),
                    (i =
                      null !== (r = s.mLockedItems.get(n.id)) && void 0 !== r
                        ? r
                        : 0),
                    s.mLockedItems.set(n.id, i | e))
                  : s.mLockedItems.set(t, e));
            }),
            this.eventLocksChanged.trigger();
        }),
        (r.prototype.isItemLocked = function (e, t) {
          if (e instanceof o.ArticleItem) {
            var r = e.getMainArticle();
            if (r !== e) return this.isItemLocked(r, t);
          }
          var n = this.mLockedItems.get(e.id);
          return null != n && 0 != (n & t);
        }),
        (r.prototype.isDeleteLocked = function (e) {
          if (this.areItemsLocked(e, 1)) return !0;
          for (var t = 0, r = e; t < r.length; t++) {
            var n = r[t];
            if (n.isGroup && this.areChildsLocked(n, 1)) return !0;
            if ('SetArticle' === n.type && this.areSetPartsLocked(n, 4))
              return !0;
          }
          return !1;
        }),
        (r.prototype.isConfigurationLocked = function (e) {
          return this.areItemsLocked(e, 2);
        }),
        (r.prototype.isCalculationLocked = function (e) {
          if (this.areItemsLocked(e, 4)) return !0;
          for (var t = 0, r = e; t < r.length; t++) {
            var n = r[t];
            if ('SetArticle' === n.type && this.areSetPartsLocked(n, 4))
              return !0;
            if ('Folder' === n.type && this.areChildsLocked(n, 4)) return !0;
          }
          return !1;
        }),
        (r.prototype.isImageLocked = function (e) {
          return this.areItemsLocked(e, 16);
        }),
        (r.prototype.isHeaderCalculationLocked = function () {
          var r = !1;
          return (
            this.mLockedItems.forEach(function (e, t) {
              null == (4 & e) || (r = !0);
            }),
            r
          );
        }),
        (r.prototype.areItemPropertiesLocked = function (e) {
          return this.areItemsLocked(e, 8);
        }),
        (r.prototype.areItemsLocked = function (e, t) {
          if (0 === e.length || 0 === t) return !1;
          for (var r = 0, n = e; r < n.length; r++) {
            var i = n[r];
            if (this.isItemLocked(i, t)) return !0;
          }
          return !1;
        }),
        (r.prototype.areSetPartsLocked = function (e, t) {
          for (var r = 0, n = e.getSetParts(); r < n.length; r++) {
            var i = n[r];
            if (this.isItemLocked(i, t)) return !0;
          }
          return !1;
        }),
        (r.prototype.areChildsLocked = function (e, t) {
          for (var r = 0, n = e.children; r < n.length; r++) {
            var i = n[r];
            if (this.isItemLocked(i, t) || this.areChildsLocked(i, t))
              return !0;
          }
          return !1;
        }),
        r);
      function r(e, t) {
        var r = this;
        void 0 === t && (t = new Map()),
          (this.eventLocksChanged = new n.utils.ListenableEvent(this)),
          (this.onItemDisposed = function (e) {
            r.mLockedItems.delete(e.id) && r.eventLocksChanged.trigger();
          }),
          (this.mBasket = e),
          this.setLockedItems(t),
          this.mBasket.eventItemDisposed.addListener(this.onItemDisposed);
      }
      o.ItemLockManager = t;
    })((n = e.wcf || (e.wcf = {})).bsk || (n.bsk = {}));
  })((egr = egr || {})),
  (function (e) {
    var o, t, r;
    function n(e) {
      (this.eventSettingsChanged = new o.utils.ListenableEvent(this)),
        (this.eventProjectDataChanged = new o.utils.ListenableEvent(this)),
        (this.eventAppDataChanged = new o.utils.ListenableEvent(this)),
        (this.eventAddressDataChanged = new o.utils.ListenableEvent(this)),
        (this.eventContactDataChanged = new o.utils.ListenableEvent(this)),
        (this.mSession = e),
        (this.mSettings = null),
        (this.mSettingsLock = new o.utils.async.Lock()),
        (this.mProjectData = null),
        (this.mProjectDataLock = new o.utils.async.Lock()),
        (this.mAddressData = new Map()),
        (this.mAddressDataLock = new o.utils.async.Lock()),
        (this.mContactData = null),
        (this.mContactDataLock = new o.utils.async.Lock()),
        (this.mAppData = new o.utils.GroupedMap()),
        (this.mAppDataLock = new o.utils.async.Lock());
    }
    (o = e.wcf || (e.wcf = {})),
      (t = o.bsk || (o.bsk = {})),
      Object.defineProperty(n.prototype, 'session', {
        get: function () {
          return this.mSession;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (n.prototype.getSettings = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mSettingsLock.acquireLock()];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 5, 6]),
                  null != this.mSettings
                    ? [3, 4]
                    : [4, this.mSession.session.getProjectSettings()]
                );
              case 3:
                (r = e.sent()),
                  (this.mSettings =
                    null != r ? r : new o.eaiws.session.ProjectSettings()),
                  (e.label = 4);
              case 4:
                return [2, this.mSettings];
              case 5:
                return t.unlock(), [7];
              case 6:
                return [2];
            }
          });
        });
      }),
      (n.prototype.changeSettings = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mSettingsLock.acquireLock()];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 4, 5]),
                  [4, this.mSession.session.setProjectSettings(r)]
                );
              case 3:
                return (
                  e.sent(),
                  this.notifyProjectDataChanged(),
                  this.notifySettingsChanged(),
                  [3, 5]
                );
              case 4:
                return t.unlock(), [7];
              case 5:
                return [2];
            }
          });
        });
      }),
      (n.prototype.getProjectData = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mProjectDataLock.acquireLock()];
              case 1:
                return (t = e.sent()), [4, this.mAddressDataLock.acquireLock()];
              case 2:
                (r = e.sent()), (e.label = 3);
              case 3:
                return (
                  e.trys.push([3, , 6, 7]),
                  null != this.mProjectData
                    ? [3, 5]
                    : [4, this.mSession.project.getProjectData()]
                );
              case 4:
                if (
                  ((n = e.sent()),
                  (this.mProjectData =
                    null != n ? n : new o.eaiws.project.ProjectData()),
                  null != this.mProjectData.addresses)
                )
                  for (
                    i = 0, a = this.mProjectData.addresses;
                    i < a.length;
                    i++
                  )
                    (s = a[i]), this.mAddressData.set(s.addressType, s);
                e.label = 5;
              case 5:
                return [2, this.mProjectData];
              case 6:
                return t.unlock(), r.unlock(), [7];
              case 7:
                return [2];
            }
          });
        });
      }),
      (n.prototype.changeProjectData = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mProjectDataLock.acquireLock()];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 4, 5]),
                  [4, this.mSession.project.setProjectData(r)]
                );
              case 3:
                return (
                  e.sent(),
                  this.notifyProjectDataChanged(),
                  this.notifySettingsChanged(),
                  [3, 5]
                );
              case 4:
                return t.unlock(), [7];
              case 5:
                return [2];
            }
          });
        });
      }),
      (n.prototype.notifyProjectDataChanged = function () {
        (this.mProjectData = null), this.eventProjectDataChanged.trigger();
      }),
      (n.prototype.getAppData = function (u, h) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mAppDataLock.acquireLock()];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                for (
                  e.trys.push([2, , 5, 6]),
                    r = new Map(),
                    n = new Array(),
                    i = 0,
                    a = h;
                  i < a.length;
                  i++
                )
                  (s = a[i]),
                    void 0 !== (o = this.mAppData.getData(u, s))
                      ? r.set(s, o)
                      : n.push(s);
                return 0 < n.length
                  ? [4, this.mSession.session.getProjectAppData(u, n)]
                  : [3, 4];
              case 3:
                for (l = e.sent(), c = 0; c < n.length; ++c)
                  r.set(n[c], l[c]), this.mAppData.setData(u, n[c], l[c]);
                e.label = 4;
              case 4:
                return [2, r];
              case 5:
                return t.unlock(), [7];
              case 6:
                return [2];
            }
          });
        });
      }),
      (n.prototype.setAppData = function (i, a) {
        return __awaiter(this, void 0, void 0, function () {
          var t,
            r,
            n = this;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mAppDataLock.acquireLock()];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 4, 5]),
                  0 === a.size
                    ? [2]
                    : ((r = new Array()),
                      a.forEach(function (e, t) {
                        r.push(t + '=' + (null == e ? '' : e));
                      }),
                      [4, this.mSession.session.setProjectAppData(i, r)])
                );
              case 3:
                return (
                  e.sent(),
                  a.forEach(function (e, t) {
                    n.mAppData.setData(i, t, e);
                  }),
                  this.eventAppDataChanged.trigger(),
                  [3, 5]
                );
              case 4:
                return t.unlock(), [7];
              case 5:
                return [2];
            }
          });
        });
      }),
      (n.prototype.getAddressData = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.fetchAddressData([r])];
              case 1:
                return (
                  e.sent(),
                  [2, null != (t = this.mAddressData.get(r)) ? t : null]
                );
            }
          });
        });
      }),
      (n.prototype.fetchAddressData = function (h) {
        return __awaiter(this, void 0, void 0, function () {
          var t,
            r,
            n,
            i,
            a,
            s,
            o,
            l,
            c,
            u = this;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mAddressDataLock.acquireLock()];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                for (
                  e.trys.push([2, , 5, 6]), r = void 0, n = 0, i = h;
                  n < i.length;
                  n++
                )
                  (a = i[n]),
                    void 0 === (c = this.mAddressData.get(a)) &&
                      (null == r && (r = new Set()), r.add(a));
                return null != r && 0 < r.size
                  ? [4, this.mSession.project.getAddressData(Array.from(r))]
                  : [3, 4];
              case 3:
                for (s = e.sent(), o = 0, l = s; o < l.length; o++)
                  (c = l[o]),
                    this.mAddressData.set(c.addressType, c),
                    r.delete(c.addressType);
                r.forEach(function (e) {
                  return u.mAddressData.set(e, null);
                }),
                  (e.label = 4);
              case 4:
                return [3, 6];
              case 5:
                return t.unlock(), [7];
              case 6:
                return [2];
            }
          });
        });
      }),
      (n.prototype.removeAddressData = function (l) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mAddressDataLock.acquireLock()];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 4, 5]),
                  [4, this.mSession.project.removeAddressData(l)]
                );
              case 3:
                for (r = e.sent(), n = 0, i = r; n < i.length; n++)
                  (o = i[n]), this.mAddressData.delete(o);
                for (a = 0, s = r; a < s.length; a++)
                  (o = s[a]), this.eventAddressDataChanged.trigger(o);
                return 0 < r.length && this.notifyProjectDataChanged(), [3, 5];
              case 4:
                return t.unlock(), [7];
              case 5:
                return [2];
            }
          });
        });
      }),
      (n.prototype.changeOrAddAddressData = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mAddressDataLock.acquireLock()];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 4, 5]),
                  [4, this.mSession.project.setAddressData(r)]
                );
              case 3:
                return (
                  e.sent(),
                  this.mAddressData.delete(r.addressType),
                  this.eventAddressDataChanged.trigger(r.addressType),
                  null != r.contacts &&
                    this.notifyContactDataChanged(
                      r.contacts.map(function (e) {
                        return e.id;
                      }),
                      r.addressType
                    ),
                  this.notifyProjectDataChanged(),
                  [3, 5]
                );
              case 4:
                return t.unlock(), [7];
              case 5:
                return [2];
            }
          });
        });
      }),
      (n.prototype.getContactData = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mContactDataLock.acquireLock()];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 5, 6]),
                  null != this.mContactData
                    ? [3, 4]
                    : [4, (r = this).mSession.project.getContactData()]
                );
              case 3:
                (r.mContactData = e.sent()), (e.label = 4);
              case 4:
                return [2, this.mContactData];
              case 5:
                return t.unlock(), [7];
              case 6:
                return [2];
            }
          });
        });
      }),
      (n.prototype.changeOrAddContactData = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mContactDataLock.acquireLock()];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 4, 5]),
                  [4, this.mSession.project.setContactData(r)]
                );
              case 3:
                return (
                  e.sent(),
                  this.notifyContactDataChanged([r.id]),
                  this.notifyProjectDataChanged(),
                  [3, 5]
                );
              case 4:
                return t.unlock(), [7];
              case 5:
                return [2];
            }
          });
        });
      }),
      (n.prototype.removeContactData = function (n) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mContactDataLock.acquireLock()];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 4, 5]),
                  [4, this.mSession.project.removeContactData(void 0, n)]
                );
              case 3:
                return (
                  (r = e.sent()),
                  this.notifyContactDataChanged(r),
                  this.notifyProjectDataChanged(),
                  [3, 5]
                );
              case 4:
                return t.unlock(), [7];
              case 5:
                return [2];
            }
          });
        });
      }),
      (n.prototype.clear = function () {
        (this.mSettings = null),
          (this.mProjectData = null),
          (this.mAddressData = new Map()),
          (this.mContactData = null),
          this.mAppData.clear();
      }),
      (n.prototype.notifyContactDataChanged = function (i, a) {
        var s = this;
        0 !== i.length &&
          (this.mAddressData.forEach(function (e) {
            if (null != e && null != e.contacts && e.addressType !== a)
              for (var t = 0, r = e.contacts; t < r.length; t++) {
                var n = r[t];
                if (o.utils.array.contains(i, n.id))
                  return void s.eventAddressDataChanged.trigger(e.addressType);
              }
          }),
          (this.mContactData = null),
          this.eventContactDataChanged.trigger());
      }),
      (n.prototype.notifySettingsChanged = function () {
        (this.mSettings = null), this.eventSettingsChanged.trigger();
      }),
      (r = n),
      (t.ProjectInfo = r);
  })((egr = egr || {})),
  (function (e) {
    var a, t, r, n;
    function i() {
      return (null !== r && r.apply(this, arguments)) || this;
    }
    (a = e.wcf || (e.wcf = {})),
      (t = a.bsk || (a.bsk = {})),
      (r = t.ArticleItem),
      __extends(i, r),
      Object.defineProperty(i.prototype, 'isGroup', {
        get: function () {
          return !0;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(i.prototype, 'isOfmlArticle', {
        get: function () {
          return !1;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(i.prototype, 'is3dConfiguration', {
        get: function () {
          return !1;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (i.prototype.setLabel = function (e) {
        return t.ArticleItem.SetShortText(this, e);
      }),
      (i.prototype.setShortText = function (e) {
        return t.ArticleItem.SetShortText(this, e);
      }),
      (i.prototype.setLongText = function (e) {
        return t.ArticleItem.SetLongText(this, e);
      }),
      (i.prototype.setFeatureText = function (e) {
        return t.ArticleItem.SetFeatureText(this, e);
      }),
      (i.prototype.setManufacturerId = function (e) {
        return t.ArticleItem.SetManufacturerId(this, e);
      }),
      (i.prototype.setSeriesId = function (e) {
        return t.ArticleItem.SetSeriesId(this, e);
      }),
      (i.prototype.setArticleNumber = function (e) {
        return t.ArticleItem.SetArticleNumber(this, e);
      }),
      (i.prototype.getSetParts = function () {
        var e = new Array();
        if (null != this.mItem.setArticlePartIds)
          for (var t = 0, r = this.mItem.setArticlePartIds; t < r.length; t++) {
            var n = r[t],
              i = this.mManager.getItemById(n);
            null != i ? e.push(i) : a.utils.Log.warn('Unknown set part: ' + n);
          }
        return e;
      }),
      (i.prototype.generateImageUrl = function () {
        return (this.mImageUrl = ''), Promise.resolve();
      }),
      (n = i),
      (t.SetArticleItem = n);
  })((egr = egr || {})),
  (function (e) {
    var r, t, n, i;
    function a() {
      return (null !== n && n.apply(this, arguments)) || this;
    }
    (r = e.wcf || (e.wcf = {})),
      (t = r.bsk || (r.bsk = {})),
      (n = t.BasketItem),
      __extends(a, n),
      (a.prototype.setLabel = function (e) {
        var t = new r.eaiws.basket.ItemProperties();
        return (
          (t.textItem = new r.eaiws.basket.TextItemProperties()),
          (t.textItem.text = e.trim()),
          this.setItemProperties(t, !0, !1)
        );
      }),
      (i = a),
      (t.TextItem = i);
  })((egr = egr || {})),
  (function (e) {
    var i, t, r, n;
    function a() {
      return (null !== r && r.apply(this, arguments)) || this;
    }
    (i = e.wcf || (e.wcf = {})),
      (t = i.bsk || (i.bsk = {})),
      (r = t.ArticleItem),
      __extends(a, r),
      Object.defineProperty(a.prototype, 'isOfmlArticle', {
        get: function () {
          return !1;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (a.prototype.setLabel = function (e) {
        return t.ArticleItem.SetShortText(this, e);
      }),
      (a.prototype.setShortText = function (e) {
        return t.ArticleItem.SetShortText(this, e);
      }),
      (a.prototype.setLongText = function (e) {
        return t.ArticleItem.SetLongText(this, e);
      }),
      (a.prototype.setFeatureText = function (e) {
        return t.ArticleItem.SetFeatureText(this, e);
      }),
      (a.prototype.setManufacturerId = function (e) {
        return t.ArticleItem.SetManufacturerId(this, e);
      }),
      (a.prototype.setSeriesId = function (e) {
        return t.ArticleItem.SetSeriesId(this, e);
      }),
      (a.prototype.setArticleNumber = function (e) {
        return t.ArticleItem.SetArticleNumber(this, e);
      }),
      (a.prototype.setPrice = function (e, t, r) {
        var n = new i.eaiws.basket.ItemProperties();
        return (
          (n.article = new i.eaiws.basket.ArticleProperties()),
          (n.article.purchasePrice = e),
          (n.article.salesPrice = t),
          (n.article.currency = r),
          this.setItemProperties(n, !1, !0)
        );
      }),
      (a.prototype.setPackagingNetWeight = function (e, t) {
        var r = new i.eaiws.basket.ItemProperties();
        return (
          (r.article = new i.eaiws.basket.ArticleProperties()),
          (r.article.packagingInfo = new i.eaiws.basket.PackagingInfo()),
          (r.article.packagingInfo.netWeight = new i.eaiws.basket.Quantity()),
          (r.article.packagingInfo.netWeight.value = e),
          (r.article.packagingInfo.netWeight.unit = t),
          this.setItemProperties(r, !1, !0)
        );
      }),
      (a.prototype.setPackagingVolume = function (e, t) {
        var r = new i.eaiws.basket.ItemProperties();
        return (
          (r.article = new i.eaiws.basket.ArticleProperties()),
          (r.article.packagingInfo = new i.eaiws.basket.PackagingInfo()),
          (r.article.packagingInfo.volume = new i.eaiws.basket.Quantity()),
          (r.article.packagingInfo.volume.value = e),
          (r.article.packagingInfo.volume.unit = t),
          this.setItemProperties(r, !1, !1)
        );
      }),
      (a.prototype.setTaxInformation = function (t, r) {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [
                  4,
                  this.mManager.session.basket.setTaxInformation(this.id, t, r),
                ];
              case 1:
                return e.sent(), [2, this.updateItem(26)];
            }
          });
        });
      }),
      (a.prototype.generateImageUrl = function () {
        return (this.mImageUrl = null), Promise.resolve();
      }),
      (n = a),
      (t.UserArticleItem = n);
  })((egr = egr || {})),
  (function (e) {
    var a, i, s, t;
    function o(e, t) {
      var r = s.call(this, e.session) || this;
      return (
        (r.mBasket = e),
        (r.mViewId = t),
        (r.mBasketItemIdMap = new Map()),
        (r.mIsUpToDate = !0),
        r
      );
    }
    (a = e.wcf || (e.wcf = {})),
      (i = a.bsk || (a.bsk = {})),
      (s = i.BaseItemManager),
      __extends(o, s),
      Object.defineProperty(o.prototype, 'viewId', {
        get: function () {
          return this.mViewId;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(o.prototype, 'viewConfig', {
        get: function () {
          return this.mViewConfig;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(o.prototype, 'basket', {
        get: function () {
          return this.mBasket;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(o.prototype, 'generatedImageResolution', {
        get: function () {
          return this.mBasket.generatedImageResolution;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (o.prototype.update = function () {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return this.mIsUpToDate
                  ? [2]
                  : ((this.mIsUpToDate = !0),
                    this.mBasketItemIdMap.clear(),
                    [4, this.mRoot.updateItem(-2147483647)]);
              case 1:
                return e.sent(), [2];
            }
          });
        });
      }),
      (o.prototype.getItemByBasketId = function (e) {
        var t = this.mBasketItemIdMap.get(e);
        return null == t ? null : this.getItemById(t);
      }),
      (o.prototype.deleteItems = function (a, s) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                for (t = new Array(), r = 0, n = a; r < n.length; r++)
                  (i = n[r]), t.push.apply(t, i.getBasketItems());
                return [4, this.mBasket.deleteItems(t, s)];
              case 1:
                return e.sent(), [2, this.update()];
            }
          });
        });
      }),
      (o.prototype.cloneItem = function (i) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (0 === (t = i.getBasketItems()).length)
                  throw a.utils.newError(
                    a.utils.ERR_FAILED,
                    'No basket item found.'
                  );
                if (1 < t.length && 'Compact' !== this.mViewConfig.mergeMode)
                  throw a.utils.newError(
                    a.utils.ERR_FAILED,
                    'Not supported for merged items.'
                  );
                return [4, this.mBasket.cloneItem(t[0])];
              case 1:
                return (r = e.sent()), [4, this.update()];
              case 2:
                if ((e.sent(), null == (n = this.getItemByBasketId(r.id))))
                  throw a.utils.newError(
                    a.utils.ERR_FAILED,
                    'View item not found.'
                  );
                return [2, n];
            }
          });
        });
      }),
      (o.prototype._getPricingProcedure = function () {
        return this.mBasket.calculation.pricingProcedure;
      }),
      (o.prototype._getGeneratedImageOptions = function () {
        return this.mBasket._getGeneratedImageOptions();
      }),
      (o.prototype.createItem = function (e, t, r) {
        var n;
        switch (r.itemType) {
          case 'Folder':
            n = new i.ViewFolderItem(this, e, t, r);
            break;
          case 'PartialPlanning':
          case 'Aggregate':
          case 'Article':
            n = new i.ViewArticleItem(this, e, t, r);
            break;
          case 'UserArticle':
            n = new i.ViewUserArticleItem(this, e, t, r);
            break;
          case 'SetArticle':
            n = new i.ViewSetArticleItem(this, e, t, r);
            break;
          case 'Text':
            n = new i.ViewTextItem(this, e, t, r);
            break;
          default:
            n = new i.ViewItem(this, e, t, r);
        }
        return n;
      }),
      (o._CreateView = function (r, n) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, (t = new o(r, n)).initialize()];
              case 1:
                return e.sent(), [2, t];
            }
          });
        });
      }),
      (o.prototype._dispose = function () {
        this.internalClear(),
          this.mBasketItemIdMap.clear(),
          (this.mBasket = void 0),
          (this.mSession = void 0);
      }),
      (o.prototype._addEaiwsItemToCache = function (e) {
        if (
          (s.prototype._addEaiwsItemToCache.call(this, e),
          null != e.basketItemIds)
        )
          for (var t = 0, r = e.basketItemIds; t < r.length; t++) {
            var n = r[t];
            this.mBasketItemIdMap.set(n, e.itemId);
          }
      }),
      (o.prototype._updateViewItem = function (n, i) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  0 != (1 & (t = 2147483647 & i)) &&
                    ((t &= -2), (this.mIsUpToDate = !1)),
                  null == (r = this.getItemByBasketId(n.id))
                    ? [3, 2]
                    : (0 != (8 & t) &&
                        null != this._getPricingProcedure() &&
                        (t |= 2),
                      [4, r.updateItem(t)])
                );
              case 1:
                return e.sent(), [3, 3];
              case 2:
                (this.mIsUpToDate = !1), (e.label = 3);
              case 3:
                return [2];
            }
          });
        });
      }),
      (o.prototype.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [
                  4,
                  this.mSession.basket.getBasketViewConfigs([this.mViewId]),
                ];
              case 1:
                if (1 !== (t = e.sent()).length)
                  throw a.utils.newError(
                    a.utils.ERR_FAILED,
                    'Failed to get basket view config.'
                  );
                return (this.mViewConfig = t[0]), [4, this.loadRootFolder()];
              case 2:
                return e.sent(), [2];
            }
          });
        });
      }),
      (t = o),
      (i.View = t);
  })((egr = egr || {})),
  (function (e) {
    var a, n, t, r;
    function i() {
      return (null !== t && t.apply(this, arguments)) || this;
    }
    (a = e.wcf || (e.wcf = {})),
      (n = a.bsk || (a.bsk = {})),
      (t = n.BaseItem),
      __extends(i, t),
      Object.defineProperty(i.prototype, 'view', {
        get: function () {
          return this.mManager;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (i.prototype.getFirstBasketItem = function () {
        return null == this.mItem.basketItemIds ||
          0 === this.mItem.basketItemIds.length
          ? null
          : this.mManager.basket.getItemById(this.mItem.basketItemIds[0]);
      }),
      (i.prototype.getBasketItems = function () {
        var e = new Array();
        if (null != this.mItem.basketItemIds)
          for (var t = 0, r = this.mItem.basketItemIds; t < r.length; t++) {
            var n = r[t],
              i = this.mManager.basket.getItemById(n);
            null != i
              ? e.push(i)
              : a.utils.Log.warn('Unknown basket item: ' + n);
          }
        return e;
      }),
      (i.prototype.findSetArticle = function () {
        var e = this.getFirstBasketItem();
        if (null == e) return null;
        var t = e.getSetArticle();
        if (null == t) return null;
        var r = this.mManager.getItemByBasketId(t.id);
        return r instanceof n.ViewSetArticleItem ? r : null;
      }),
      (r = i),
      (n.ViewItem = r);
  })((egr = egr || {})),
  (function (e) {
    var o, r, t, n;
    function i() {
      return (null !== t && t.apply(this, arguments)) || this;
    }
    (o = e.wcf || (e.wcf = {})),
      (r = o.bsk || (o.bsk = {})),
      (t = r.ViewItem),
      __extends(i, t),
      Object.defineProperty(i.prototype, 'isOfmlArticle', {
        get: function () {
          return !0;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (i.prototype.setQuantity = function (n) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, (t = this._getConfigArticleItem(!1)).setQuantity(n)];
              case 1:
                return (
                  e.sent(),
                  (r = t.getMainArticle()),
                  'SubArticles' === this.mManager.viewConfig.mergeMode &&
                    null != r.item.subArticleIds &&
                    0 < r.item.subArticleIds.length &&
                    this.mManager._updateViewItem(r, 1),
                  [2, this.mManager.update()]
                );
            }
          });
        });
      }),
      (i.prototype.findMainArticle = function () {
        var e = this.getFirstBasketItem();
        if (!(e instanceof r.ArticleItem && e.isSubArticle())) return null;
        var t = this.mManager.getItemByBasketId(e.id);
        return t instanceof i ? t : null;
      }),
      (i.prototype._getConfigArticleItem = function (e) {
        if (
          null == this.mItem.basketItemIds ||
          0 === this.mItem.basketItemIds.length
        )
          throw o.utils.newError(o.utils.ERR_FAILED, 'No basket item found.');
        if (
          1 < this.mItem.basketItemIds.length &&
          !e &&
          'Compact' !== this.mManager.viewConfig.mergeMode
        )
          throw o.utils.newError(
            o.utils.ERR_FAILED,
            'Not supported for merged items.'
          );
        var t = this.getFirstBasketItem();
        if (t instanceof r.ArticleItem) return t;
        throw o.utils.newError(
          o.utils.ERR_FAILED,
          'Basket item is not an article.'
        );
      }),
      (i.prototype.generateImageUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                (this.mImageUrl = null), (n = !(r = t = null));
                try {
                  t = this._getConfigArticleItem(!0);
                } catch (e) {
                  o.utils.Log.error('Failed to get config item.', e);
                }
                return (
                  null != t &&
                    ((r = t._getCameraSetup()),
                    (n = t._shouldRequestStoredImage())),
                  null == r || n ? [4, this.getStoredImage()] : [3, 2]
                );
              case 1:
                if (null != (i = e.sent()))
                  return (
                    null != t &&
                      null == r &&
                      t._setCameraSetup(this.getCameraSetupFromImage(i)),
                    (this.mImageUrl = i.url),
                    [2]
                  );
                e.label = 2;
              case 2:
                return [4, this.getGeneratedImage(r)];
              case 3:
                return (
                  (a = e.sent()),
                  o.utils.string.isNullOrEmpty(a)
                    ? [4, this.getCatalogImage()]
                    : ((this.mImageUrl = a), [2])
                );
              case 4:
                return (
                  (s = e.sent()),
                  o.utils.string.isNullOrEmpty(s) || (this.mImageUrl = s),
                  [2]
                );
            }
          });
        });
      }),
      (n = i),
      (r.ViewArticleItem = n);
  })((egr = egr || {})),
  (function (e) {
    var t, r, n, i;
    function a() {
      return (null !== n && n.apply(this, arguments)) || this;
    }
    (t = e.wcf || (e.wcf = {})),
      (r = t.bsk || (t.bsk = {})),
      (n = r.ViewItem),
      __extends(a, n),
      Object.defineProperty(a.prototype, 'isGroup', {
        get: function () {
          return !0;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (i = a),
      (r.ViewFolderItem = i);
  })((egr = egr || {})),
  (function (e) {
    var t, r, n, i;
    function a() {
      return (null !== n && n.apply(this, arguments)) || this;
    }
    (t = e.wcf || (e.wcf = {})),
      (r = t.bsk || (t.bsk = {})),
      (n = r.ViewArticleItem),
      __extends(a, n),
      Object.defineProperty(a.prototype, 'isGroup', {
        get: function () {
          return !0;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(a.prototype, 'isOfmlArticle', {
        get: function () {
          return !1;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (a.prototype.generateImageUrl = function () {
        return (this.mImageUrl = ''), Promise.resolve();
      }),
      (i = a),
      (r.ViewSetArticleItem = i);
  })((egr = egr || {})),
  (function (e) {
    var t, r, n, i;
    function a() {
      return (null !== n && n.apply(this, arguments)) || this;
    }
    (t = e.wcf || (e.wcf = {})),
      (r = t.bsk || (t.bsk = {})),
      (n = r.ViewItem),
      __extends(a, n),
      (i = a),
      (r.ViewTextItem = i);
  })((egr = egr || {})),
  (function (e) {
    var t, r, n, i;
    function a() {
      return (null !== n && n.apply(this, arguments)) || this;
    }
    (t = e.wcf || (e.wcf = {})),
      (r = t.bsk || (t.bsk = {})),
      (n = r.ViewArticleItem),
      __extends(a, n),
      Object.defineProperty(a.prototype, 'isOfmlArticle', {
        get: function () {
          return !1;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (a.prototype.generateImageUrl = function () {
        return (this.mImageUrl = null), Promise.resolve();
      }),
      (i = a),
      (r.ViewUserArticleItem = i);
  })((egr = egr || {})),
  (function (e) {
    var v, b, t, r;
    function a(e) {
      var a = this;
      (this.onArticleChanged = function (e) {
        var t;
        null == e ||
          null == e.article ||
          null == e.article.basketId ||
          (null != (t = e.article.getMainArticle()) &&
            a.mChangedMainElements.add(t));
      }),
        (this.onArticleAdded = function (e) {
          var t, r, n, i;
          null != e &&
            null != e.basketId &&
            ((t = e.getMainArticle()),
            a.mChangedMainElements.add(t),
            e !== t
              ? ((r = null) == (n = t.basketId) ||
                  (null != (i = a.mBasket.getItemById(n)) && (r = i.parent)),
                null == r && (r = a.mMainParent),
                a.mParentItemsToUpdate.add(r.id))
              : a.mParentItemsToUpdate.add(a.mMainParent.id));
        }),
        (this.onArticleRemoved = function (e) {
          var t, r, n, i;
          null != e &&
            null != e.basketId &&
            ((t = e.getMainArticle()),
            a.mChangedMainElements.add(t),
            e !== t
              ? ((r = null) != (n = a.mBasket.getItemById(e.basketId)) &&
                  n instanceof b.ArticleItem &&
                  (null == (r = n.parent) && (r = a.mMainParent),
                  (r === (i = n.getMainArticle()) ||
                    (r instanceof b.ArticleItem && r.getMainArticle() === i)) &&
                    (r = null)),
                null != r && a.mParentItemsToUpdate.add(r.id))
              : a.mParentItemsToUpdate.add(a.mMainParent.id));
        }),
        (this.onArticleInstanceRestored = function (e) {
          null != e &&
            null != e.basketId &&
            (a.mRestoredInstances.add(e.basketId),
            a.mChangedMainElements.add(e),
            a.mParentItemsToUpdate.add(a.mMainParent.id));
        }),
        (this.onModelModified = function () {
          a.mLiveBasketUpdate && a.synchronizeBasket(!1);
        }),
        (this.eventBasketChanged = new v.utils.ListenableEvent(this)),
        (this.mBasket = e),
        (this.mParentItemsToUpdate = new Set()),
        (this.mChangedMainElements = new Set()),
        (this.mRestoredInstances = new Set()),
        (this.mAssignedCameras = new Map()),
        this.reset(!1);
    }
    (v = e.wcf || (e.wcf = {})),
      (b = v.bsk || (v.bsk = {})),
      (t = b.cfg || (b.cfg = {})),
      Object.defineProperty(a.prototype, 'started', {
        get: function () {
          return this.mStarted;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(a.prototype, 'isPreConfiguration', {
        get: function () {
          return this.mStarted && this.mIsPreConfiguration;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(a.prototype, 'articleManager', {
        get: function () {
          return this.mArticleManager;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(a.prototype, 'configurationName', {
        get: function () {
          var e = null;
          return (
            this.mStarted &&
              null != this.mMainItem &&
              (e = this.mMainItem.label),
            e
          );
        },
        enumerable: !1,
        configurable: !0,
      }),
      (a.prototype.start = function (t, r, n) {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (e) {
            if (null == t || null == r)
              throw new Error(v.utils.ERR_INVALID_ARGUMENT);
            if (this.started)
              throw v.utils.newError(
                v.utils.ERR_INVALID_STATE,
                'configuration already started'
              );
            try {
              return (
                (this.mArticleManager = t),
                (this.mApp = t.app),
                r instanceof b.ViewArticleItem
                  ? [2, this.startForArticle(r._getConfigArticleItem(!0), n)]
                  : r instanceof b.ArticleItem
                  ? [2, this.startForArticle(r, n)]
                  : [2, this.startPreConfiguration(r, n)]
              );
            } catch (e) {
              throw (this.reset(), e);
            }
            return [2];
          });
        });
      }),
      (a.prototype.startMultiConfiguration = function (e) {
        if (this.started)
          throw v.utils.newError(
            v.utils.ERR_INVALID_STATE,
            'configuration already started'
          );
        return (
          (this.mMultiPropProvider = t.MultiArticlePropertyProvider._Create(
            this.mBasket,
            e
          )),
          (this.mStarted = !0),
          Promise.resolve(this.mMultiPropProvider)
        );
      }),
      (a.prototype.assignArticleImageCamera = function (e, t, r) {
        if (r) {
          var n = e.getMainArticle(),
            i = n.getSubArticles(!1);
          this.addAssignedCamera(n, t);
          for (var a = 0, s = i; a < s.length; a++) {
            var o = s[a];
            this.addAssignedCamera(o, t);
          }
        } else this.addAssignedCamera(e, t);
        this.mLiveBasketUpdate && this.synchronizeBasket(!1);
      }),
      (a.prototype.getArticleImageCamera = function (e) {
        var t = this.mAssignedCameras.get(e);
        if (null != t) return t;
        if (null != e.basketId) {
          var r = this.mBasket.getItemById(e.basketId);
          if (null != r && r instanceof b.ArticleItem)
            return r._getCameraSetup();
        }
        return null;
      }),
      (a.prototype.resetView = function (e, t) {
        this.setupCamera({ view: e, zoomToFitOptions: t });
      }),
      (a.prototype.finish = function (t) {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return this.started
                  ? null == this.mMultiPropProvider
                    ? [3, 1]
                    : (this.mMultiPropProvider.setProviders([]),
                      (this.mMultiPropProvider = null),
                      (this.mStarted = !1),
                      [3, 4])
                  : [
                      2,
                      v.utils.rejectError(
                        v.utils.ERR_INVALID_STATE,
                        'configuration not started'
                      ),
                    ];
              case 1:
                return this.mIsPreConfiguration
                  ? [4, this.setPreConfigurationItemId(null)]
                  : [3, 3];
              case 2:
                e.sent(), (e.label = 3);
              case 3:
                return [2, this.synchronizeBasket(!0, t)];
              case 4:
                return [2];
            }
          });
        });
      }),
      (a.prototype.abort = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (!this.started)
                  throw v.utils.newError(
                    v.utils.ERR_INVALID_STATE,
                    'configuration not started'
                  );
                if (!this.mIsPreConfiguration)
                  throw v.utils.newError(
                    v.utils.ERR_NOT_AVAILABLE,
                    'only available for new articles'
                  );
                e.label = 1;
              case 1:
                if ((e.trys.push([1, , 5, 6]), null == this.mArticleManager))
                  return [3, 4];
                for (
                  t = this.mArticleManager.getAllMainArticles(), r = 0, n = t;
                  r < n.length;
                  r++
                )
                  (i = n[r]), this.mApp.model.removeElement(i);
                return [4, this.setPreConfigurationItemId(null)];
              case 2:
                return (
                  e.sent(), [4, this.mArticleManager.synchronizeSession(!1)]
                );
              case 3:
                e.sent(), (e.label = 4);
              case 4:
                return [3, 6];
              case 5:
                return this.reset(), [7];
              case 6:
                return [2];
            }
          });
        });
      }),
      (a.prototype.clear = function () {
        this.mStarted && this.reset();
      }),
      (a.prototype.loadFromSession = function (s) {
        return __awaiter(this, void 0, void 0, function () {
          var t,
            r,
            n,
            i,
            a = this;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return s ? [4, this.getPreConfigurationItemId()] : [2, null];
              case 1:
                return (
                  (t = e.sent()),
                  v.utils.string.isNullOrEmpty(t)
                    ? [2, null]
                    : [4, this.setPreConfigurationItemId(null)]
                );
              case 2:
                e.sent(), (e.label = 3);
              case 3:
                return (
                  e.trys.push([3, 6, , 7]),
                  (r = [t]),
                  [4, this.mBasket.session.basket.copy(r)]
                );
              case 4:
                return (
                  (n = e.sent()),
                  [4, this.mBasket.session.basket.deleteItems(r)]
                );
              case 5:
                return (
                  e.sent(),
                  [
                    2,
                    function (e, t) {
                      return a.restorePreConfiguration(e, n, t);
                    },
                  ]
                );
              case 6:
                return (
                  (i = e.sent()),
                  v.utils.Log.error(
                    'Failed to prepare restoration of pre configuration.',
                    i
                  ),
                  [3, 7]
                );
              case 7:
                return [2, null];
            }
          });
        });
      }),
      (a.prototype.reset = function (e) {
        void 0 === e && (e = !0),
          e &&
            null != this.mApp &&
            null != this.mArticleManager &&
            (this.deregisterEvents(),
            this.mApp.document.clear(),
            (this.mArticleManager.fatherItemId = this.mOldFatherItemId),
            this.mArticleManager.setPricingProcedure(
              this.mOldPricingProcedure
            )),
          (this.mStarted = !1),
          (this.mLiveBasketUpdate = !1),
          (this.mArticleManager = null),
          (this.mApp = void 0),
          (this.mMultiPropProvider = null),
          (this.mIsPreConfiguration = !1),
          (this.mIsSetArticle = !1),
          (this.mMainParent = void 0),
          (this.mMainItem = null),
          (this.mPreConfigMainItemId = null),
          (this.mOldFatherItemId = null),
          (this.mOldPricingProcedure = null),
          this.clearTrackedChanges();
      }),
      (a.prototype.clearTrackedChanges = function () {
        this.mParentItemsToUpdate.clear(),
          this.mChangedMainElements.clear(),
          this.mRestoredInstances.clear(),
          this.mAssignedCameras.clear();
      }),
      (a.prototype.registerEvents = function () {
        null != this.mArticleManager &&
          (this.mArticleManager.eventArticleChanged.addListener(
            this.onArticleChanged
          ),
          this.mArticleManager.eventArticleAdded.addListener(
            this.onArticleAdded
          ),
          this.mArticleManager.eventArticleRemoved.addListener(
            this.onArticleRemoved
          ),
          this.mArticleManager.eventArticleInstanceRestored.addListener(
            this.onArticleInstanceRestored
          )),
          this.mApp.model.eventModified.addListener(this.onModelModified);
      }),
      (a.prototype.deregisterEvents = function () {
        null != this.mArticleManager &&
          (this.mArticleManager.eventArticleChanged.removeListener(
            this.onArticleChanged
          ),
          this.mArticleManager.eventArticleAdded.removeListener(
            this.onArticleAdded
          ),
          this.mArticleManager.eventArticleRemoved.removeListener(
            this.onArticleRemoved
          ),
          this.mArticleManager.eventArticleInstanceRestored.removeListener(
            this.onArticleInstanceRestored
          )),
          this.mApp.model.eventModified.removeListener(this.onModelModified);
      }),
      (a.prototype.startForArticle = function (I, _) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c, u, h, m, d, p, g, f;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == this.mArticleManager)
                  throw v.utils.newError(
                    v.utils.ERR_INVALID_STATE,
                    'mArticleManager == null'
                  );
                if (
                  ((this.mStarted = !0),
                  (this.mLiveBasketUpdate =
                    null != _ && !0 === _.liveBasketUpdate),
                  (this.mIsPreConfiguration = !1),
                  (this.mIsSetArticle = !1),
                  (this.mOldFatherItemId = this.mArticleManager.fatherItemId),
                  (this.mOldPricingProcedure = this.mArticleManager.pricingProcedure),
                  this.mArticleManager.setPricingProcedure(
                    this.mBasket.calculation.pricingProcedure
                  ),
                  (t = I.getMainArticle()),
                  (r = null),
                  (r = I instanceof b.SetArticleItem ? I : t.getSetArticle()),
                  (n = new Array()),
                  (i = new Array()),
                  (a = new Map()),
                  null != r && r.is3dConfiguration)
                )
                  for (
                    this.mIsSetArticle = !0,
                      this.mMainParent = r,
                      this.mMainItem = r,
                      this.mArticleManager.fatherItemId = r.id,
                      s = r.getSetParts(),
                      o = 0,
                      l = s;
                    o < l.length;
                    o++
                  )
                    (c = l[o]) instanceof b.ArticleItem &&
                      (n.push(c.id),
                      null != (u = c._getCachedConfigData()) &&
                        null != u.gfjUrl &&
                        a.set(c.id, u.gfjUrl),
                      this.collectArticleBasketItems(c, i));
                else
                  (this.mMainItem = t),
                    (this.mMainParent =
                      null != t.parent ? t.parent : this.mBasket.root),
                    (this.mArticleManager.fatherItemId = this.mMainParent.id),
                    n.push(t.id),
                    null != (u = t._getCachedConfigData()) &&
                      null != u.gfjUrl &&
                      a.set(t.id, u.gfjUrl),
                    this.collectArticleBasketItems(t, i);
                return [
                  4,
                  this.mArticleManager.createArticlesById(
                    n,
                    this.mIsSetArticle,
                    i,
                    a
                  ),
                ];
              case 1:
                for (h = e.sent(), m = null, d = 0, p = h; d < p.length; d++)
                  (g = p[d]),
                    this.mApp.model.addElement(g),
                    this.fillMainElementCache(g),
                    g.basketId === t.id && (m = g);
                return (
                  null != m
                    ? (this.mApp.model.setSelection([m]),
                      I.isSubArticle() &&
                        ((f = m.getSubArticleById(I.id)),
                        this.mApp.model.setSubElementSelection(m, f)))
                    : this.mApp.model.setSelection(null),
                  [4, this.setupCamera(_)]
                );
              case 2:
                return e.sent(), this.registerEvents(), [2, h];
            }
          });
        });
      }),
      (a.prototype.collectArticleBasketItems = function (e, t) {
        var r = e.getSubArticles(!0);
        t.push(e.item);
        for (var n = 0, i = r; n < i.length; n++) {
          var a = i[n];
          t.push(a.item);
        }
      }),
      (a.prototype.restorePreConfiguration = function (n, i, a) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (this.started)
                  throw v.utils.newError(
                    v.utils.ERR_INVALID_STATE,
                    'configuration already started'
                  );
                e.label = 1;
              case 1:
                return (
                  e.trys.push([1, 3, , 4]),
                  (this.mArticleManager = n),
                  (this.mApp = n.app),
                  [4, this.mBasket.session.basket.paste(null, null, i)]
                );
              case 2:
                if (null == (t = e.sent()) || t.length < 1)
                  throw v.utils.newError(
                    v.utils.ERR_FAILED,
                    'Failed to restore pre configuration.'
                  );
                return [2, this.startPreConfiguration(t[0], a)];
              case 3:
                throw ((r = e.sent()), this.reset(), r);
              case 4:
                return [2];
            }
          });
        });
      }),
      (a.prototype.startPreConfiguration = function (r, n) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == this.mArticleManager)
                  throw v.utils.newError(
                    v.utils.ERR_INVALID_STATE,
                    'mArticleManager == null'
                  );
                return (
                  (this.mStarted = !0),
                  (this.mIsPreConfiguration = !0),
                  (this.mIsSetArticle = !1),
                  (this.mMainParent = this.mBasket.root),
                  (this.mOldFatherItemId = this.mArticleManager.fatherItemId),
                  (this.mOldPricingProcedure = this.mArticleManager.pricingProcedure),
                  this.mArticleManager.setPricingProcedure(
                    this.mBasket.calculation.pricingProcedure
                  ),
                  (this.mMainItem = null),
                  (this.mArticleManager.fatherItemId = null),
                  r instanceof v.eaiws.catalog.ArticleCatalogItem
                    ? [4, this.mArticleManager.insertArticle(r)]
                    : [3, 2]
                );
              case 1:
                return (t = e.sent()), [3, 4];
              case 2:
                return [4, this.mArticleManager.createArticleById(r)];
              case 3:
                (t = e.sent()), (e.label = 4);
              case 4:
                return [4, this.setPreConfigurationItemId(t.basketId)];
              case 5:
                return (
                  e.sent(),
                  (this.mPreConfigMainItemId = t.basketId),
                  this.registerEvents(),
                  this.mApp.model.addElement(t),
                  this.mApp.model.setSelection([t]),
                  [4, this.setupCamera(n)]
                );
              case 6:
                return e.sent(), [2, [t]];
            }
          });
        });
      }),
      (a.prototype.setPreConfigurationItemId = function (e) {
        var t = a.APP_DATA_PRECONFIGURATION_ITEM + '=';
        return (
          null != e && (t += e),
          this.mBasket.session.basket.setBasketAppData(a.APP_KEY, [t])
        );
      }),
      (a.prototype.getPreConfigurationItemId = function () {
        return this.mBasket.session.basket
          .getBasketAppData(a.APP_KEY, [a.APP_DATA_PRECONFIGURATION_ITEM])
          .then(function (e) {
            return null == e || 1 !== e.length ? null : e[0];
          });
      }),
      (a.prototype.setupCamera = function (i) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n;
          return __generator(this, function (e) {
            if (null == i || null == i.view) return [2];
            null != this.mMainItem
              ? (null != this.mArticleManager &&
                  null !=
                    (r = this.mArticleManager.getArticleById(
                      this.mMainItem.id
                    )) &&
                  (t = this.mAssignedCameras.get(r)),
                null == t && (t = this.mMainItem._getCameraSetup()))
              : this.mIsPreConfiguration &&
                null != this.mPreConfigMainItemId &&
                null != this.mArticleManager &&
                null !=
                  (r = this.mArticleManager.getArticleById(
                    this.mPreConfigMainItemId
                  )) &&
                (t = this.mAssignedCameras.get(r)),
              null == t && (t = a.DEFAULT_CAMERA_SETUP),
              (n = BABYLON.Quaternion.RotationYawPitchRoll(
                v.utils.math.degToRad(-t.alpha),
                v.utils.math.degToRad(t.beta),
                0
              ));
            try {
              i.view.cameraControl.beginChange(),
                (i.view.cameraControl.cameraMode =
                  'Perspective' === t.mode ? 7 : 6),
                i.view.cameraControl.setDirection(
                  v.utils.math.rotateVector3(v.utils.math.VECTOR3_Z, n)
                ),
                i.view.cameraControl.setFov(v.utils.math.degToRad(t.fov)),
                null != i.zoomToFitOptions &&
                  i.view.cameraControl.zoomToFitElements(
                    null,
                    i.zoomToFitOptions
                  );
            } finally {
              i.view.cameraControl.endChange();
            }
            return [2];
          });
        });
      }),
      (a.prototype.addAssignedCamera = function (e, t) {
        var r, n, i, a, s;
        null != t
          ? ((r = t.cameraControl.right.clone()),
            (n = t.cameraControl.direction.clone()),
            (i = BABYLON.Vector3.Cross(n, r)),
            BABYLON.Vector3.TransformCoordinatesToRef(r, e.worldTransform, r),
            BABYLON.Vector3.TransformCoordinatesToRef(i, e.worldTransform, i),
            BABYLON.Vector3.TransformCoordinatesToRef(n, e.worldTransform, n),
            (a = v.utils.math.quaternionFromAxes(r, i, n).toEulerAngles()),
            ((s = {}).mode =
              7 === t.cameraControl.cameraMode
                ? 'Perspective'
                : 'Orthographic'),
            (s.alpha = v.utils.math.radToDeg(-a.y)),
            (s.beta = v.utils.math.radToDeg(a.x)),
            (s.fov = v.utils.math.radToDeg(t.camera.fov)),
            'Orthographic' === s.mode
              ? s.beta <= -90
                ? ((s.alpha = 0), (s.beta = -90))
                : 90 <= s.beta && ((s.alpha = 0), (s.beta = 90))
              : s.beta <= -90
              ? (s.beta = -90 + v.utils.math.EPSILON)
              : 90 <= s.beta && (s.beta = 90 - v.utils.math.EPSILON),
            this.mAssignedCameras.set(e, s))
          : this.mAssignedCameras.set(e, null);
      }),
      (a.prototype.fillMainElementCache = function (e) {
        if (null != e.basketId) {
          var t = this.mBasket.getItemById(e.basketId);
          if (null != t && t instanceof b.ArticleItem) {
            var r = t.getSubArticles(!0);
            r.push(t);
            for (
              var n = new Array(), i = new Map(), a = new Map(), s = 0, o = r;
              s < o.length;
              s++
            ) {
              var l = o[s],
                c = l.getCachedItemProperties();
              null != c && n.push(c);
              var u = l.getCachedCalculation();
              null != u && i.set(t.id, u);
              var h = l._getCachedConfigData();
              null != h && a.set(t.id, h);
            }
            e.fillItemPropertiesCache(n),
              e.fillCalculationCache(i),
              e.fillConfigDataCache(a);
          }
        }
      }),
      (a.prototype.fillBasketCache = function () {
        var i = this;
        if (0 === this.mChangedMainElements.size) return null;
        var a = new Array();
        return (
          this.mChangedMainElements.forEach(function (e) {
            null != e.basketId && a.push(e.basketId),
              i.addArticleDataToCache(e);
            for (var t = 0, r = e.getSubArticles(!1); t < r.length; t++) {
              var n = r[t];
              i.addArticleDataToCache(n);
            }
          }),
          a
        );
      }),
      (a.prototype.fillBasketConfigDataCache = function () {
        if (null == this.mArticleManager)
          throw v.utils.newError(
            v.utils.ERR_INVALID_STATE,
            'mArticleManager == null'
          );
        for (
          var e = 0, t = this.mArticleManager.getAllMainArticles();
          e < t.length;
          e++
        ) {
          var r = t[e];
          this.addConfigDataToCache(r);
          for (var n = 0, i = r.getSubArticles(!1); n < i.length; n++) {
            var a = i[n];
            this.addConfigDataToCache(a);
          }
        }
      }),
      (a.prototype.addArticleDataToCache = function (e) {
        var t, r, n;
        null != e &&
          null != e.basketId &&
          (null != (t = e.getCachedBasketItem()) &&
            this.mBasket._addEaiwsItemToCache(t),
          null != (r = e.getCachedItemProperties()) &&
            this.mBasket._addItemPropsToCache(r),
          null != (n = e.getCachedCalculation()) &&
            this.mBasket._addCalculationInfoToCache(e.basketId, n));
      }),
      (a.prototype.addConfigDataToCache = function (e) {
        var t;
        null == e ||
          null == e.basketId ||
          ((t = this.mBasket.getItemById(e.basketId)) instanceof
            b.ArticleItem &&
            t._setCachedConfigData(e.getCachedConfigData()));
      }),
      (a.prototype.synchronizeBasket = function (p, g) {
        return __awaiter(this, void 0, void 0, function () {
          var n,
            t,
            r,
            i,
            a,
            s,
            o,
            l,
            c,
            u,
            h,
            m,
            d = this;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == this.mArticleManager)
                  throw v.utils.newError(
                    v.utils.ERR_INVALID_STATE,
                    'mArticleManager == null'
                  );
                (n = !1), (e.label = 1);
              case 1:
                return (
                  e.trys.push([1, , 23, 24]),
                  this.mBasket._beginItemUpdate(),
                  this.mBasket._beginCaching(),
                  p ||
                    null == this.mApp.appCallbacks.beginAsyncOperation ||
                    this.mApp.appCallbacks.beginAsyncOperation(),
                  (t = this.mIsPreConfiguration && null != g),
                  [
                    4,
                    this.mArticleManager.synchronizeSession(
                      p && (this.mIsSetArticle || t)
                    ),
                  ]
                );
              case 2:
                return (
                  e.sent(), p ? (t ? [4, this.createSet(g)] : [3, 4]) : [3, 6]
                );
              case 3:
                return e.sent(), [3, 6];
              case 4:
                return this.mIsSetArticle ? [4, this.updateSet(g)] : [3, 6];
              case 5:
                e.sent(), (e.label = 6);
              case 6:
                return null == (r = this.fillBasketCache())
                  ? [3, 8]
                  : [4, this.mBasket._fetchEaiwsItems(r, !1, !0)];
              case 7:
                e.sent(), (e.label = 8);
              case 8:
                return 0 < this.mParentItemsToUpdate.size
                  ? ((i = Array.from(this.mParentItemsToUpdate)),
                    [4, this.mBasket._fetchEaiwsItems(i, !1, !1)])
                  : [3, 16];
              case 9:
                e.sent(), (a = 0), (s = i), (e.label = 10);
              case 10:
                return a < s.length
                  ? ((u = s[a]),
                    null == (o = this.mBasket.getItemById(u))
                      ? [3, 12]
                      : [4, o.updateItem(1)])
                  : [3, 13];
              case 11:
                e.sent(), o.invalidateGroupCalculations(), (e.label = 12);
              case 12:
                return a++, [3, 10];
              case 13:
                return null != this.mMainItem && this.mIsSetArticle
                  ? [4, this.mMainItem.updateItem(2)]
                  : [3, 15];
              case 14:
                e.sent(), (e.label = 15);
              case 15:
                (n = !0), (e.label = 16);
              case 16:
                if (this.mIsPreConfiguration || null == r) return [3, 21];
                (l = 0), (c = r), (e.label = 17);
              case 17:
                return l < c.length
                  ? ((u = c[l]),
                    null != (h = this.mBasket.getItemById(u)) &&
                    h instanceof b.ArticleItem
                      ? [4, h.updateWholeComposite(-65)]
                      : [3, 19])
                  : [3, 20];
              case 18:
                e.sent(), (e.label = 19);
              case 19:
                return l++, [3, 17];
              case 20:
                (n = !0), (e.label = 21);
              case 21:
                return (
                  (m = new Array()),
                  this.mAssignedCameras.forEach(function (e, t) {
                    var r;
                    null == t.basketId ||
                      (null != (r = d.mBasket.getItemById(t.basketId)) &&
                        r instanceof b.ArticleItem &&
                        r._getCameraSetup() !== e &&
                        (r._setCameraSetup(e),
                        m.push(r.updateItem(4)),
                        (n = !0)));
                  }),
                  [4, Promise.all(m)]
                );
              case 22:
                return e.sent(), p && this.fillBasketConfigDataCache(), [3, 24];
              case 23:
                return (
                  p ||
                    null == this.mApp.appCallbacks.endAsyncOperation ||
                    this.mApp.appCallbacks.endAsyncOperation(),
                  p ? this.reset() : this.clearTrackedChanges(),
                  this.mBasket._endCaching(),
                  this.mBasket._endItemUpdate(),
                  n && this.eventBasketChanged.trigger(),
                  [7]
                );
              case 24:
                return [2];
            }
          });
        });
      }),
      (a.prototype.createSet = function (p) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c, u, h, m, d;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == this.mArticleManager)
                  throw v.utils.newError(
                    v.utils.ERR_INVALID_STATE,
                    'mArticleManager == null'
                  );
                for (
                  t = this.mBasket.session.basket,
                    r = new Array(),
                    n = this.mArticleManager.getAllMainArticles(),
                    i = 0,
                    a = n;
                  i < a.length;
                  i++
                )
                  if (null != (s = a[i]).basketId)
                    for (
                      r.push(s.basketId),
                        o = s.getSubArticles(!1),
                        l = 0,
                        c = o;
                      l < c.length;
                      l++
                    )
                      null != (u = c[l]).basketId && r.push(u.basketId);
                return [4, t.insertFolder(null, null, p)];
              case 1:
                return (h = e.sent()), [4, t.convertToSetArticle(h)];
              case 2:
                return (
                  (m = e.sent()),
                  this.mIsPreConfiguration && (this.mPreConfigMainItemId = m),
                  0 < r.length ? [4, t.relocateItems(m, null, r)] : [3, 5]
                );
              case 3:
                if ('Done' !== (d = e.sent()))
                  throw new Error('Failed to relocate items: ' + d);
                return [4, t.addToSetArticle(r)];
              case 4:
                e.sent(), (e.label = 5);
              case 5:
                return [2];
            }
          });
        });
      }),
      (a.prototype.updateSet = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return null == r || null == this.mMainItem
                  ? [3, 2]
                  : (((t = new v.eaiws.basket.ItemProperties()).article = new v.eaiws.basket.ArticleProperties()),
                    (t.article.shortText = r),
                    [
                      4,
                      this.mBasket.session.basket.setItemProperties(
                        this.mMainItem.id,
                        t
                      ),
                    ]);
              case 1:
                e.sent(),
                  this.mParentItemsToUpdate.add(this.mMainParent.id),
                  (e.label = 2);
              case 2:
                return 0 < this.mRestoredInstances.size
                  ? [
                      4,
                      this.mBasket.session.basket.addToSetArticle(
                        Array.from(this.mRestoredInstances)
                      ),
                    ]
                  : [3, 4];
              case 3:
                e.sent(),
                  this.mParentItemsToUpdate.add(this.mMainParent.id),
                  (e.label = 4);
              case 4:
                return [2];
            }
          });
        });
      }),
      (a.APP_KEY = 'W-CF'),
      (a.APP_DATA_PRECONFIGURATION_ITEM = 'basket/preConfigurationItem'),
      (a.DEFAULT_CAMERA_SETUP = {
        alpha: -15,
        beta: 20,
        fov: 30,
        mode: 'Perspective',
      }),
      (r = a),
      (t.ArticleConfigurationImpl = r);
  })((egr = egr || {})),
  (function (e) {
    var i, t, r, n;
    function a(e, t, r) {
      var n = this;
      (this.eventPropertiesChanged = new i.utils.ListenableEvent(this)),
        (this.onSetPropertyValue = function (a, s) {
          return __awaiter(n, void 0, void 0, function () {
            var t, r, n, i;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  if (null == a) return [2, 0];
                  if (
                    ((t = ''),
                    null != s && (t = s.toString()),
                    t === a.value.value)
                  )
                    return [2, 0];
                  e.label = 1;
                case 1:
                  return (
                    e.trys.push([1, 3, , 4]),
                    [
                      4,
                      this.mBasket.session.basket.setPropertyValue(
                        this.mArticle.id,
                        a.propClass,
                        a.propName,
                        t
                      ),
                    ]
                  );
                case 2:
                  return null != (r = e.sent()) && 'U' !== r
                    ? ((n = -1 !== r.indexOf('r') || -1 !== r.indexOf('a')),
                      this.mMultiProvider._notifyMainArticleChanged(
                        this.mArticle.getMainArticle(),
                        n
                      ),
                      this.eventPropertiesChanged.trigger(2),
                      [2, 2])
                    : [3, 4];
                case 3:
                  return (
                    (i = e.sent()),
                    this.mMultiProvider.eventSetPropValueError.trigger(i),
                    [3, 4]
                  );
                case 4:
                  return [2, 0];
              }
            });
          });
        }),
        (this.mBasket = e),
        (this.mMultiProvider = t),
        (this.mArticle = r);
    }
    (i = e.wcf || (e.wcf = {})),
      (t = i.bsk || (i.bsk = {})),
      (r = t.cfg || (t.cfg = {})),
      (a.prototype.getProperties = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mArticle._getArticleData()];
              case 1:
                return (
                  (t = e.sent()),
                  [
                    2,
                    i.cf.ArticlePropertyHelpers.GetProperties(
                      this.mArticle.id,
                      this.mBasket.session,
                      this,
                      t,
                      this.onSetPropertyValue
                    ),
                  ]
                );
            }
          });
        });
      }),
      (a.prototype.getPropertyClasses = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.mArticle._getArticleData()];
              case 1:
                return (
                  (t = e.sent()),
                  [2, i.cf.ArticlePropertyHelpers.GetPropertyClasses(t)]
                );
            }
          });
        });
      }),
      (a.prototype.beginPropertyChange = function () {}),
      (a.prototype.endPropertyChange = function () {}),
      (n = a),
      (r.ArticlePropertyProvider = n);
  })((egr = egr || {})),
  (function (e) {
    var r, t, n, i, a;
    function s(e) {
      var t = i.call(this, null) || this;
      return (
        (t.eventSetPropValueError = new r.utils.ListenableEvent(t)),
        (t.mBasket = e),
        (t.mChangedParents = null),
        (t.mChangedMainArticles = null),
        t
      );
    }
    (r = e.wcf || (e.wcf = {})),
      (t = r.bsk || (r.bsk = {})),
      (n = t.cfg || (t.cfg = {})),
      (i = r.core.prop.MultiPropertyProvider),
      __extends(s, i),
      (s._Create = function (t, e) {
        var r = new s(t);
        return (
          r.setProviders(
            e.map(function (e) {
              return new n.ArticlePropertyProvider(t, r, e);
            })
          ),
          r
        );
      }),
      (s.prototype._notifyMainArticleChanged = function (e, t) {
        null != this.mChangedParents &&
          t &&
          this.mChangedParents.add(
            null == e.parent ? this.mBasket.root : e.parent
          ),
          null != this.mChangedMainArticles && this.mChangedMainArticles.add(e);
      }),
      (s.prototype.beginSetPropertyValue = function () {
        (this.mChangedParents = new Set()),
          (this.mChangedMainArticles = new Set()),
          i.prototype.beginSetPropertyValue.call(this);
      }),
      (s.prototype.endSetPropertyValue = function () {
        (this.mChangedParents = null),
          (this.mChangedMainArticles = null),
          i.prototype.endSetPropertyValue.call(this);
      }),
      (s.prototype.finalizeSetPropertyValue = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (
                  null == this.mChangedMainArticles ||
                  0 === this.mChangedMainArticles.size
                )
                  return [2];
                e.label = 1;
              case 1:
                return (
                  e.trys.push([1, , 12, 13]),
                  this.mBasket._beginItemUpdate(),
                  this.mBasket._beginCaching(),
                  (t = Array.from(this.mChangedMainArticles)),
                  [
                    4,
                    this.mBasket._fetchEaiwsItems(
                      t.map(function (e) {
                        return e.id;
                      }),
                      !1,
                      !0
                    ),
                  ]
                );
              case 2:
                return (
                  e.sent(),
                  null != this.mChangedParents && 0 < this.mChangedParents.size
                    ? ((r = Array.from(this.mChangedParents)),
                      [
                        4,
                        this.mBasket._fetchEaiwsItems(
                          r.map(function (e) {
                            return e.id;
                          }),
                          !1,
                          !1
                        ),
                      ])
                    : [3, 7]
                );
              case 3:
                e.sent(), (n = 0), (i = r), (e.label = 4);
              case 4:
                return n < i.length ? [4, (a = i[n]).updateItem(1)] : [3, 7];
              case 5:
                e.sent(), a.invalidateGroupCalculations(), (e.label = 6);
              case 6:
                return n++, [3, 4];
              case 7:
                (s = 0), (o = t), (e.label = 8);
              case 8:
                return s < o.length
                  ? [4, o[s].updateWholeComposite(-65)]
                  : [3, 11];
              case 9:
                e.sent(), (e.label = 10);
              case 10:
                return s++, [3, 8];
              case 11:
                return [3, 13];
              case 12:
                return (
                  this.mBasket._endCaching(), this.mBasket._endItemUpdate(), [7]
                );
              case 13:
                return [2];
            }
          });
        });
      }),
      (a = s),
      (n.MultiArticlePropertyProvider = a);
  })((egr = egr || {}));
